import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {
  pages,
  lobbyTabsEnum,
  otpValidationPopupContent,
  popupReasonEnum,
  saleOTPSteps,
  customerTypeEnum,
  saleActiveStep,
  searchParametersEnum,
  businessIndividualSteps,
} from './cellcomAbroadVariables';
import {otpValidatedEventGAReport, otpValidatedSeparatedSale} from './gAPopupsLoadingReport';
import {selectParametersGAReport, gaPackagesEmptyResult} from './gaReports';
import {validateFields, validateField} from '../../../utilities/validation/validator';
import {regexPatterns, validationRules} from '../../../utilities/validation/validationVariables';
import lodash from 'lodash';
import {setItem, removeItem} from '../../../utilities/localStorageUtils';
import {enqueueRequest} from '../../../utilities/apiQueue';
import {report, getReportParams} from '../../../middleware/report';
import {formatDatesToDifferentFormats, getPackageEndDate} from './cellcomAbroadUtilities';
import {createOtpLogin, validateOtpLogin, saveLoginData} from 'app/utilities/authentication/authenticationSlice';
import AuthenticationProvider from '../../../utilities/authentication/authenticationProvider';
import {
  getDwhParams,
  dwhSelectAccountBusinessIndividualReport,
  dwhSetSelectedAbroadPackage,
  dwhAutoPackagePopupBusinessIndividual,
  dwhRoamPopupBusinessIndividual,
  dwhDataUsageBlockedPopupBusinessIndividual,
  dwhPackageSearchActivation,
  dwhValidateCustomer,
  errorOnOTPStep1,
  dwhErrorValidateCustomer,
  dwhAbroadAddonsSuccessPage,
  dwhAbroadAddonsPopup,
} from './dwhReports.js';
import {getOnboardingSubs} from 'app/Components/Page/SelfCarePage/SelfCareAsyncThunk.js';
import {gaFailedOrderAddon, gaSuccessOrderAddon} from 'app/Components/Block/AbroadTicketBlock/gaReports';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import authenticationProvider from 'app/utilities/authentication/authenticationProvider';
import Config from 'app/Config';
import {rolesKeys} from 'app/Components/Block/OTPLoginBlock/Assets/variables';
import {TAB_ENUM} from 'app/Components/Page/SelfCarePage/Constant';
import EpiContext from '@episerver/spa-core/Spa';
import {
  GetAbroadAdditionalServices,
  getCustomerAbroadPackages,
  updatePackage,
  removePackage,
  removeCapSoc,
  abroadRemoveAndAddSoc,
  getCustomerAbroadUsageDisplay,
  fetchPackagePopular,
  fetchPackagePopularMarket,
  getUsageData,
  addAddonToPackage,
  getCustomerAbroadPackagesBusinessIndividual,
  abroadRemoveAndAddSocFamily,
  FetchFamilyBundleUsages,
} from './Shared/abroadThunk';
import {PackageType} from './Shared/Models/AbroadPackageModels';
import {selfServiceDwh} from '../../../utilities/SelfServiceDwh';
import {FamilyBundleStatus} from 'app/Components/Block/AbroadCustomerUsageGraphsBlock/FamilyPackageUsageDetailsPopUp/utils/constants';
export const PostCollaborationInsurance = createAsyncThunk('cellcomAbroad/PostCollaborationInsurance', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());

    const result = await ProviderManager.getProviderData('PostCollaborationInsurance', [
      data.Scope,
      data.ClientId,
      data.ClientSecret,
      data.LoginType,
      data.Sid,
      data.SubscriberNumber,
    ]);

    return {
      data: result?.Body?.access_token,
      error: false,
    };
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      data: '',
      error: true,
    };
  }
});

export const GetCollaborationInsuranceData = createAsyncThunk('cellcomAbroad/GetCollaborationInsuranceData', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('GetCollaborationInsuranceData', [data.subscriber]);
    thunkAPI.dispatch(hideAppLoader());
    return {
      error: false,
      data: result,
    };
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      data: {},
      error: true,
    };
  }
});

export const IsCollaborationInsuranceAllowed = createAsyncThunk('cellcomAbroad/IsCollaborationInsuranceAllowed', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('IsCollaborationInsuranceAllowed', [data.subscriber]);
    thunkAPI.dispatch(hideAppLoader());

    return {
      error: false,
      allowed: result.Body,
    };
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      error: true,
    };
  }
});

export const GetShadowClientBillData = createAsyncThunk('cellcomAbroad/GetShadowClientBillData', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('RetrieveShadowClientBillData', [data.subscriber]);
    return result;
  } catch (error) {
    return {
      error: true,
    };
  }
});

export const PlantShadowMemo = createAsyncThunk('cellcomAbroad/PlantShadowMemo', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('PlantShadowMemo', [
      data.banId,
      data.soc,
      data.subscriber,
      data.shadowBan,
      data.memoType,
    ]);
    return result;
  } catch (error) {
    return {
      error: true,
    };
  }
});

export const RemoveAndAddShadowSoc = createAsyncThunk('cellcomAbroad/RemoveAndAddShadowSoc', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('RemoveAndAddShadowSoc', [
      data.idNumber,
      data.firstName,
      data.lastName,
      data.subscriber,
      data.ccMonth,
      data.ccYear,
      data.ccType,
      data.ccNumber,
      data.authNum,
      data.clientMail,
      data.socCode,
      data.referenceSocCode,
      data.shadowBan,
      data.startDate,
      data.endDate,
      data.countries,
      data.blockId,
      data.fromExisting,
      data.allowIndependentFuturePurchases,
      data.couponCode,
      data.couponSerial,
    ]);
    return result;
  } catch (error) {
    return {
      error: true,
      reason: error,
    };
  }
});

export const GetShadowSubscriberData = createAsyncThunk('cellcomAbroad/GetShadowSubscriberData', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('GetShadowSubscriber', [data.subscriber]);
    return result;
  } catch (error) {
    return {
      error: true,
    };
  }
});

export const GetDebtIssuesIndication = createAsyncThunk('cellcomAbroad/GetDebtIssuesIndication', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('GetDebtIssuesIndicator', [data.id, data.subscriber]);
    return result;
  } catch (error) {
    return {
      error: true,
    };
  }
});
export const getAddonsPackage = createAsyncThunk('cellcomAbroad/getAddonsPackage', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getAddonsPackageByBlockId', [data.blockId]);
    return result;
  } catch (error) {
    return {
      error: true,
    };
  }
});

export const PlantMemoBeforePackagePurchase = createAsyncThunk('cellcomAbroad/PlantMemoBeforePackagePurchase', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('PlantMemoBeforePurchase', [
      data.banId,
      data.soc,
      data.subscriber,
      data.countries,
      data.startDate,
      data.endDate,
    ]);
    return result;
  } catch (error) {
    return {
      error: true,
    };
  }
});

export const UpdateEmailOfCustomer = createAsyncThunk('cellcomAbroad/UpdateEmailOfCustomer', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('UpdateCustomerEmail', [data.ban, data.email, data.subscriber]);
    return result;
  } catch (error) {
    return {
      error: true,
    };
  }
});

export const SubmitCreateShadowCustomer = createAsyncThunk('cellcomAbroad/SubmitCreateShadowCustomer', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('CreateShadowCustomer', [
      data.idNumber,
      data.firstName,
      data.lastName,
      data.subscriber,
      data.ccMonth,
      data.ccYear,
      data.ccType,
      data.ccNumber,
      data.clientMail,
    ]);
    return result;
  } catch (error) {
    return {
      error: true,
    };
  }
});

export const UpdateShadowClientCard = createAsyncThunk('cellcomAbroad/UpdateShadowClientCard', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('UpdateShadowCC', [
      data.ccMonth,
      data.ccYear,
      data.ccType,
      data.ccNumber,
      data.banId,
      data.clientId,
      data.subscriber,
      data.authNo,
    ]);
    return result;
  } catch (error) {
    return {
      error: true,
    };
  }
});

export const getRetrieveTariffPrices = createAsyncThunk('cellcomAbroad/getRetrieveTariffPrices', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getRetrieveTariffPrices', [data.country, data.soc, data.blockId]);
    return result;
  } catch (error) {
    return {
      error: true,
      reason: error,
    };
  }
});

export const getExtendedPackageData = createAsyncThunk('cellcomAbroad/getExtendedPackageData', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(setLoading(true));
    const result = await ProviderManager.getProviderData('getExtendedPackageData', [data.blockId, data.userType, data.phoneNumber]);
    thunkAPI.dispatch(setLoading(false));
    return result;
  } catch (error) {
    thunkAPI.dispatch(setLoading(false));
    return {
      error: true,
      reason: error,
    };
  }
});

export const abroadAddSoc = createAsyncThunk('cellcomAbroad/abroadAddSoc', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(setLoading(true));
    const result = await ProviderManager.getProviderData('abroadAddSoc', [data.phoneNumber, data.socCode]);
    thunkAPI.dispatch(setLoading(false));
    return result;
  } catch (error) {
    thunkAPI.dispatch(setLoading(false));
    return {
      error: true,
      reason: error,
    };
  }
});

export const getEpiGeneralData = createAsyncThunk('cellcomAbroad/getEpiGeneralData', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('getCellcomAbroadEpiGeneralData', []);
    return {
      error: false,
      data: result.Body,
    };
  } catch (error) {
    return {
      error: true,
    };
  }
});

export const abroadCountriesSearched = createAsyncThunk('cellcomAbroad/abroadCountriesSearched', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('abroadCountriesSearched', [data]);
    return {
      error: false,
      data: result.Body,
    };
  } catch (error) {
    return {
      error: true,
    };
  }
});

export const verifyPhone = createAsyncThunk('cellcomAbroad/verifyPhone', async (data, thunkAPI) => {
  try {
    const isChild = thunkAPI.getState().cellcomAbroad.selectedAbroadPackage?.isFamilyBonus;
    if (isChild) {
      const result = await ProviderManager.getProviderData('createOtp', [
        data.phoneNumber,
        data.asVoice,
        data.captchaToken,
        '',
        data.otpOrigin,
        data.originProcess,
      ]);
      return {
        result: result.Body,
        otpPhone: data.phoneNumber,
      };
    } else {
      // LoginStep1 args: Subscriber, ProcessType, OtpOrigin, OriginProcess, LoginType, GenericFields
      const res = await ProviderManager.getProviderData('LoginStep1', [
        data.phoneNumber,
        '',
        data.otpOrigin,
        data.originProcess,
        '',
        '',
      ]);
      const endObject = {
        result: {
          step1Ticket: res.Body?.message,
          deliveryType: data.asVoice ? 'TextToSpeech' : 'Sms',
          creationDate: new Date().toISOString().slice(0, 19),
          restrictedCodeRequired: res.Body?.resultMessage == 'OTP_RESTRICT_CODE_REQUIRE',
        },
        otpPhone: data.phoneNumber,
        subscriberNotExists: res.error?.message && res.error?.message == 'SUBSCRIBER_NUMBER_NOT_EXISTS',
      };
      return endObject;
    }
  } catch (error) {
    return {
      error: true,
      msg: error,
    };
  }
});

export const validateOtpCode = createAsyncThunk('cellcomAbroad/validateOtpCode', async (data, thunkAPI) => {
  try {
    const isChild = thunkAPI.getState().cellcomAbroad.selectedAbroadPackage?.isFamilyBonus;
    if (isChild) {
      const result = await ProviderManager.getProviderData('validateOtp', [
        data.otpPhone,
        data.otpTicketId,
        data.otpCode,
        data.otpOrigin,
        data.originProcess,
      ]);

      return result.Header.ReturnCode == 0;
    } else {
      const sendData = {code: data.otpCode, otpOrigin: data.otpOrigin, originProcess: data.originProcess};
      const res = await thunkAPI.dispatch(validateOtpLogin(sendData));
      if (res.type.includes('rejected')) {
        let code = '';
        try {
          code = res.error.name.replace('Error ', '');
        } catch (error) {}
        return {
          error: true,
          errorData: {
            errorCode: code,
          },
        };
      } else {
        const isLogin = res.payload?.loginData?.isOtpAuthenticated ? true : false;
        return isLogin;
      }
    }
  } catch (error) {
    return {
      error: true,
      errorData: error,
    };
  }
});

export const validateAbroadCoupon = createAsyncThunk('cellcomAbroad/validateAbroadCoupon', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('validateAbroadCoupon', [
      data.soc_code,
      data.coupon_code,
      data.phoneNumber,
      data.channel,
    ]);
    return result;
  } catch (error) {
    return {error: true};
  }
});
export const getCustomerCellularList = createAsyncThunk('cellcomAbroad/getCustomerCellularList', async (data, thunkAPI) => {
  try {
    /* const OnboardingData = await ProviderManager.getProviderData('OnboardingData', {});
    const subscribersByProduct = OnboardingData?.Body?.subscribersByProduct[TAB_ENUM.Cellular];
    const subscribers = subscribersByProduct.map((product) => product.productSubscriberNo);*/
    const subscribers = await thunkAPI.dispatch(getOnboardingSubs());
    return {data: subscribers.payload, error: false};
  } catch (error) {
    return {error: true};
  }
});

export const validateCustomerType = createAsyncThunk('cellcomAbroad/validateCustomerType', async (data, thunkAPI) => {
  let thisStore = thunkAPI.getState();
  const isLoginAuth = thisStore?.authentication?.loginData?.isFullAuthenticated;
  let cellularSubscribers = thisStore?.selfcarePage?.subscribersByProduct?.Cellular || [];
  if (cellularSubscribers.length === 0) {
    await thunkAPI.dispatch(getOnboardingSubs());
    thisStore = thunkAPI.getState();
    cellularSubscribers = thisStore?.selfcarePage?.subscribersByProduct?.Cellular || [];
  }
  try {
    const result = await ProviderManager.getProviderData('validateCustomerType', [data.phoneNumber, data.type]);

    if (result.Header.ReturnCode == 0) {
      return {
        response: result.Body,
        validatedPhoneNumber: data.phoneNumber,
        isLoginAuth: isLoginAuth,
        cellularSubscribers: cellularSubscribers,
      };
    }
    return {
      error: true,
      isLoginAuth: isLoginAuth,
      validatedPhoneNumber: data.phoneNumber,
    };
  } catch (error) {
    return {
      errorData: error,
      error: true,
      isLoginAuth: isLoginAuth,
      validatedPhoneNumber: data.phoneNumber,
    };
  }
});

export const validateCustomerFamilyType = createAsyncThunk(
  'cellcomAbroad/validateCustomerFamilyType',
  async (
    {
      SubscriberNoParent,
      SubscriberChildren,
      SocCodeFamilyPackage,
      SocCodePackageGiveFamilyBonus,
      StartDateChildren,
      EndDateChildren,
      StartDateParent,
      Countries,
      BlockId,
    },
    thunkAPI,
  ) => {
    try {
      let thisStore = thunkAPI.getState();
      const result = await ProviderManager.getProviderData('ValidateFamilyPackage', [
        SubscriberNoParent,
        SubscriberChildren,
        SocCodeFamilyPackage,
        SocCodePackageGiveFamilyBonus,
        StartDateParent,
        EndDateChildren,
        StartDateChildren,
        Countries,
        BlockId,
      ]);
      if (result.Header.ReturnCode == 0) {
        return {
          response: result.Body,
          isLoginAuth: thisStore?.authentication?.loginData?.isFullAuthenticated,
        };
      }
      return {
        error: true,
        isLoginAuth: thisStore?.authentication?.loginData?.isFullAuthenticated,
      };
    } catch (error) {
      return {
        error: true,
        isLoginAuth: thunkAPI.getState()?.authentication?.loginData?.isFullAuthenticated,
      };
    }
  },
);

export const abroadRetrieveCustomerDataFamily = createAsyncThunk(
  'cellcomAbroad/abroadRetrieveCustomerDataFamily',
  async (
    {
      SubscriberNoParent,
      SubscriberChildren,
      SocCodeFamilyPackage,
      SocCodePackageGiveFamilyBonus,
      StartDateChildren,
      EndDateChildren,
      StartDateParent,
      Countries,
      BlockId,
    },
    thunkAPI,
  ) => {
    try {
      let thisStore = thunkAPI.getState();
      const result = await ProviderManager.getProviderData('ValidateFamilyPackage', [
        SubscriberNoParent,
        SubscriberChildren,
        SocCodeFamilyPackage,
        SocCodePackageGiveFamilyBonus,
        StartDateParent,
        EndDateChildren,
        StartDateChildren,
        Countries,
        BlockId,
      ]);
      if (result.Header.ReturnCode == 0) {
        return {
          response: result.Body,
          isLoginAuth: thisStore?.authentication?.loginData?.isFullAuthenticated,
        };
      }
      return {
        error: true,
        isLoginAuth: thisStore?.authentication?.loginData?.isFullAuthenticated,
      };
    } catch (error) {
      return {
        error: true,
        isLoginAuth: thunkAPI.getState()?.authentication?.loginData?.isFullAuthenticated,
      };
    }
  },
);

export const getUnqualifiedSubsFamily = createAsyncThunk(
  'cellcomAbroad/GetUnqualifiedSubsFamily',
  async ({SubscriberNoParent, SocCodePackageGiveFamilyBonus, StartDateParent}, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('GetUnqualifiedSubsFamily', [
        SubscriberNoParent,
        SocCodePackageGiveFamilyBonus,
        StartDateParent,
      ]);
      if (result.Header.ReturnCode == 0) {
        return {
          response: result.Body,
        };
      }
      return {
        error: true,
      };
    } catch (error) {
      return {
        error: true,
      };
    }
  },
);

export const abroadRetrieveCustomerData = createAsyncThunk('cellcomAbroad/abroadRetrieveCustomerData', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('abroadRetrieveCustomerData', [
      data.phoneNumber,
      data.socCode,
      data.startDate,
      data.endDate,
      data.type,
      data.countries,
      data.blockId,
    ]);
    if (result.Header.ReturnCode == 0) {
      return {result: result.Body, validatedPhone: data.phoneNumber};
    }
    return {
      error: true,
    };
  } catch (error) {
    return {
      error: true,
    };
  }
});

export const validateCustomerTypeBusinessIndividual = createAsyncThunk(
  'cellcomAbroad/validateCustomerTypeBusinessIndividual',
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('validateCustomerTypeBusinessIndividual', [
        data.phoneNumber,
        data.type,
        data.orgId,
        data.startDate,
        data.endDate,
        data.countries,
        data.socCode,
        data.packageSegment,
      ]);

      if (result.Header.ReturnCode == 0) {
        return {
          response: result.Body,
          account: data.phoneNumber,
          fullValidation: data.startDate && data.endDate && data.socCode ? true : false,
        };
      }
      return {
        error: true,
      };
    } catch (error) {
      return {
        error: true,
      };
    }
  },
);

export const fetchPackageBusinessIndividualClient = createAsyncThunk(
  'cellcomAbroad/fetchPackageBusinessIndividualClient',
  async ({CountryCodeList, DateStart, DateEnd, BlockId, GoldBusinessPackagesBlockId, PhoneNumber, OrgId}, thunkApi) => {
    let response;

    try {
      response = await ProviderManager.getProviderData('getAbroadMatchPackageBusinessIndividual', [
        CountryCodeList,
        DateStart,
        DateEnd,
        BlockId,
        GoldBusinessPackagesBlockId,
        PhoneNumber,
        OrgId,
      ]);
      return {
        response: response.Body,
        error: false,
      };
    } catch (e) {
      return {
        response: null,
        error: true,
      };
    }
  },
);

export const abroadRetrieveCustomerDataNoEffect = createAsyncThunk(
  'cellcomAbroad/abroadRetrieveCustomerDataNoEffect',
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('abroadRetrieveCustomerData', [
        data.phoneNumber,
        data.socCode,
        data.startDate,
        data.endDate,
        data.type,
        data.countries,
        data.blockId,
      ]);
      if (result.Header.ReturnCode == 0) {
        return result.Body;
      }
      return {
        error: true,
      };
    } catch (error) {
      return {
        error: true,
      };
    }
  },
);

export const checkFamilyBundleSubscribersBlockage = createAsyncThunk(
  'cellcomAbroad/checkFamilyBundleSubscribersBlockage',
  async ({phones, socCode, startDate, endDate, type, countries, blockId, packageType, primaryPhone}, thunkAPI) => {
    const isDataPackage = packageType && String(packageType).toUpperCase().includes('DATA');
    const normalizedPrimary = primaryPhone ? String(primaryPhone).trim() : null;
    if (!isDataPackage || !phones?.length) {
      return {hasBlocked: false, blockedPhones: [], primaryPhone: normalizedPrimary, primaryResult: undefined};
    }

    try {
      const results = await phones.reduce(async (accPromise, phoneNumber) => {
        const acc = await accPromise;
        const result = await new Promise((resolve) => {
          enqueueRequest(() => {
            ProviderManager.getProviderData('abroadRetrieveCustomerData', [
              phoneNumber,
              socCode,
              startDate,
              endDate,
              type,
              countries,
              blockId,
            ])
              .then((res) => {
                if (res.Header.ReturnCode == 0) {
                  resolve({phoneNumber, body: res.Body, error: false});
                } else {
                  resolve({phoneNumber, error: true});
                }
              })
              .catch(() => resolve({phoneNumber, error: true}));
          });
        });
        return [...acc, result];
      }, Promise.resolve([]));

      if (results.some((r) => r.error)) {
        return thunkAPI.rejectWithValue({error: true});
      }

      const blockedPhones = results.filter((r) => r.body?.subsriberSurfIsBlocked).map((r) => r.phoneNumber);
      const primaryEntry = normalizedPrimary ? results.find((r) => String(r.phoneNumber).trim() === normalizedPrimary) : results[0];

      return {
        hasBlocked: blockedPhones.length > 0,
        blockedPhones,
        primaryPhone: normalizedPrimary ?? primaryEntry?.phoneNumber,
        primaryResult: primaryEntry?.body,
      };
    } catch (error) {
      return thunkAPI.rejectWithValue({error: true});
    }
  },
);

export const fetchPackageClient = createAsyncThunk(
  'cellcomAbroad/fetchPackageClient',
  async ({CountryCodeList, DateStart, DateEnd, BlockId, PhoneNumber}, thunkApi) => {
    let response;

    try {
      let method = PhoneNumber ? 'getAbroadMatchPackage' : 'getAbroadMatchPackageGuest';
      response = await ProviderManager.getProviderData(method, [CountryCodeList, DateStart, DateEnd, BlockId, PhoneNumber]);
      return {
        response: response.Body,
        error: false,
      };
    } catch (e) {
      return {
        response: null,
        error: true,
      };
    }
  },
);

export const fetchPackage = createAsyncThunk('cellcomAbroad/fetchPackage', async (data, thunkApi) => {
  let response;

  try {
    response = await ProviderManager.getProviderData('getAbroadPackageDetails', [data]);
    return {
      response: response.Body,
      error: false,
    };
  } catch (e) {
    return {
      response: null,
      error: true,
    };
  }
});

export const fetchPackageBySocCode = createAsyncThunk('cellcomAbroad/fetchPackageBySocCode', async (data, thunkApi) => {
  let response;

  try {
    response = await ProviderManager.getProviderData('getAbroadPackageDetailsBySocCode', [data]);

    return {
      response: response.Body,
      error: false,
    };
  } catch (e) {
    return {
      response: null,
      error: true,
    };
  }
});

export const abroadRemoveAndAddSocBusinessIndividual = createAsyncThunk(
  'cellcomAbroad/abroadRemoveAndAddSocBusinessIndividual',
  async (data, thunkAPI) => {
    try {
      const result = await ProviderManager.getProviderData('abroadRemoveAndAddSocBusinessIndividual', [
        data.subscriberNumber,
        data.soc,
        data.startDate,
        data.endDate,
        data.countries,
        data.shouldRemoveSurfingBlockage,
        data.type,
        data.orgId,
        data.blockId,
        data.isShelf,
        data.allowIndependentFuturePurchases,
        data.isSplitBuy ? true : false,
        data.packageType,
      ]);
      return result;
    } catch (error) {
      return {
        error: true,
        errorCode: '99',
      };
    }
  },
);

export const checkHasFamilySoc = createAsyncThunk('cellcomAbroad/checkHasFamilySoc', async ({phoneNumber}, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('FamilySocData', [phoneNumber]);
    return result?.Body ?? [];
  } catch (error) {
    return thunkAPI.rejectWithValue(error);
  }
});

export const getAbroadFamilyPackageDetails = createAsyncThunk(
  'cellcomAbroad/getAbroadFamilyPackageDetails',
  async ({blockId, socCode, phoneNumber, objGetUnqualifiedSubsFamily}, thunkAPI) => {
    try {
      await thunkAPI.dispatch(getUnqualifiedSubsFamily(objGetUnqualifiedSubsFamily));
      let unqualifiedSubs = thunkAPI.getState()?.cellcomAbroad?.otpData?.unqualifiedSubs;
      let cellcomAbroad = thunkAPI.getState()?.cellcomAbroad;

      if (unqualifiedSubs < 5 && !cellcomAbroad.selectedAbroadPackage?.isFamilyBonus) {
        const result = await ProviderManager.getProviderData('getAbroadFamilyPackageDetails', [blockId, socCode, phoneNumber]);
        return result;
      } else if (unqualifiedSubs < 5 && cellcomAbroad.selectedAbroadPackage?.isFamilyBonus) {
        thunkAPI.dispatch(removeOtpDataChildren());
        thunkAPI.dispatch(goToFamily());
        throw new Error('already in family process');
      } else if (unqualifiedSubs >= 5) {
        throw new Error('children family is full');
      }
    } catch (error) {
      if (error.message === 'children family is full')
        return {
          childrenIsFull: true,
        };
      else if (error.message === 'already in family process')
        return {
          alreadyInFamilyProcess: true,
        };
      else
        return {
          error: true,
          errorCode: '99',
          childrenIsFull: false,
        };
    }
  },
);

export const getAbroadFamilyPackageInfo = createAsyncThunk(
  'cellcomAbroad/getAbroadFamilyPackageInfo',
  async ({blockId, socCode}, thunkAPI) => {
    try {
      let cellcomAbroad = thunkAPI.getState()?.cellcomAbroad;
      let phone = cellcomAbroad.otpData.otpPhone ? cellcomAbroad.otpData.otpPhone : '0';
      const result = await ProviderManager.getProviderData('getAbroadFamilyPackageDetails', [blockId, socCode, phone]);
      return result.Body;
    } catch (error) {
      return {
        error: true,
        errorCode: '99',
      };
    }
  },
);

export const validateOtpDataWithCustomerRequest = (validatedCostumerData, state, cellularSubscribers = []) => {
  if (!validatedCostumerData.subscriberExists) {
    return otpValidationPopupContent.isNotCellcomAccount;
  } else if (!validatedCostumerData.subStatusIsA) {
    return otpValidationPopupContent.subStatusIsA;
  } else if (!validatedCostumerData.dummySubIndIsNull) {
    return otpValidationPopupContent.dummySubIndIsNull;
  } else if (
    (!validatedCostumerData.sockRoamIsValid && validatedCostumerData.accountType == customerTypeEnum.BUSINESS) ||
    validatedCostumerData.noRoamSockExists
  ) {
    return otpValidationPopupContent.abroadIsClosedForAccount;
  } else if (validatedCostumerData.autoPackageExists) {
    if (validatedCostumerData.isSeparatedSale) {
      return otpValidationPopupContent.separatedSaleAutoPackage;
    } else {
      return otpValidationPopupContent.autoPackageExists;
    }
  } else if (validatedCostumerData.rollingPackageExists) {
    if (validatedCostumerData.isSeparatedSale) {
      return otpValidationPopupContent.separatedSaleRollingPackage;
    } else {
      return otpValidationPopupContent.rollingPackageExists;
    }
  } else if (!validatedCostumerData.accountTypeIsValid.item2) {
    let ans;
    switch (validatedCostumerData.accountTypeIsValid.item1) {
      case 'Talkman':
        ans = otpValidationPopupContent.talkmanAccount;
        break;
      case 'S':
      case 'B':
      case 'I':
        ans = otpValidationPopupContent.isPrivateAccount;
        break;
      case 'CantSaleNow':
        ans = 'SeparatedSale';
        break;
      case 'Business':
        if (state.activeLobbyTab === lobbyTabsEnum.BUSINESSACCOUNT) {
          ans = null;
        } else {
          const isFamilyBundle = state.selectedAbroadPackage?.isFamilyBundle;
          const hasPrivateSubscribers = isFamilyBundle && cellularSubscribers.some((s) => s.isBusinness === false);
          ans = hasPrivateSubscribers
            ? otpValidationPopupContent.isBusinessAccountWithPrivateSubscribers
            : otpValidationPopupContent.isBusinessAccount;
        }
        break;
      case 'Private':
        ans = otpValidationPopupContent.isPrivateAccount;
        break;
      case 'CellcomWorker':
        ans = otpValidationPopupContent.isCellcomWorkerOtpSale;
        break;
      case 'GeneralError':
        ans = otpValidationPopupContent.otpGeneralError;
        break;
      case 'OrgEmployeeFamilyMember':
        ans = state.otpData.approvedPopup ? null : otpValidationPopupContent.isOrgEmployeeFamilyMember;
        break;
      default:
        ans = otpValidationPopupContent.cantPurchasePackage;
    }

    return ans;
  } else if (validatedCostumerData.accountTypeIsValid.item2 && validatedCostumerData.accountTypeIsValid.item1 == 'CellcomWorker') {
    return otpValidationPopupContent.isCellcomWorkerOtpLobby;
  } else {
    return null;
  }
};

export const validateSelectedAccountBusinessIndividual = (customerData, fullValidationFlag) => {
  if (customerData.autoPackageExists) {
    return otpValidationPopupContent.autoPackageExistsBusinessIndividual;
  }
  if (!fullValidationFlag) {
    if (customerData.businessIndividualVIPClass) {
      return otpValidationPopupContent.customerGoldClass;
    } else if (customerData.businessIndividualPricePlanVoice) {
      return otpValidationPopupContent.pricePlanVoiceExists;
    }
  } else {
    if (!customerData.accountTypeIsValid.item2) {
      let ans;
      switch (customerData.accountTypeIsValid.item1) {
        case 'Gold':
          ans = otpValidationPopupContent.isNotGoldAccount;
          break;
        case 'CantSaleNow':
          ans = otpValidationPopupContent.isNotRedOrFullFinAccount;
          break;
        default:
          break;
      }
      return ans;
    } else if (!customerData.sockRoamIsValid || customerData.noRoamSockExists) {
      return otpValidationPopupContent.abroadIsClosedForAccountBusinessIndividual;
    }
  }
  return null;
};

/** @returns {'error'|'popup'|'ready'} */
function applyAbroadRetrieveResultToState(state, result, {validatedPhone, keepLoaderStep = false} = {}) {
  const stepOnPopup = keepLoaderStep ? saleActiveStep.LOADER : saleActiveStep.TICKET;

  if (!result || result.error || !result.returnResponse) {
    state.otpData.otpPopupData = otpValidationPopupContent.otpGeneralError;
    state.isShowPopup = true;
    state.popupReason = popupReasonEnum.OTP_RESULT;
    state.saleActiveStep = stepOnPopup;
    return 'error';
  }

  state.otpData.validatedCostumerData = result;

  if (result.isSeparatedSale) {
    if (!result.shadowData.shadowClientValid || (!result.shadowData.effectiveSocExists && result.shadowData.status.toUpperCase() == 'S')) {
      state.shadowProcessStage = 'DETAILS_INSERT';
    } else {
      state.shadowProcessStage = 'ID_INSERT';
    }
    if (!state.isJETAuthentication) {
      const storeData = {validatedPhone: validatedPhone};
      setItem('abroadOTP', storeData, true);
    }
  } else {
    if (result.isDefaultSoc?.length > 0) {
      const defaultPackage = result.isDefaultSoc.find((defPackage) => defPackage.alretPopUpToUser == true);
      if (defaultPackage) {
        state.otpData.otpPopupData = otpValidationPopupContent.defaultPackageExists;
        state.isShowPopup = true;
        state.popupReason = popupReasonEnum.OTP_RESULT;
        state.otpData.defaultSOC = defaultPackage;
        state.saleActiveStep = stepOnPopup;
        return 'popup';
      }
    } else if (result.subsriberSurfIsBlocked) {
      state.isShowPopup = true;
      state.popupReason = popupReasonEnum.DATA_USAGE_IS_BLOCKED;
      state.saleActiveStep = stepOnPopup;
      return 'popup';
    } else if (!result.accountSegmentMatchSoc) {
      state.isShowPopup = true;
      state.popupReason = popupReasonEnum.ACCOUNT_SEGMENT_MATCH_SOC;
      state.saleActiveStep = stepOnPopup;
      return 'popup';
    } else if (result.capSoc && state.selectedAbroadPackage.type != PackageType.Data) {
      state.isShowPopup = true;
      state.popupReason = popupReasonEnum.CAP_SOC;
      state.saleActiveStep = stepOnPopup;
      return 'popup';
    }
  }

  if (state.page == pages.SALE) {
    state.otpData.readyToPurchase = true;
  }

  if (keepLoaderStep) {
    state.saleActiveStep = saleActiveStep.LOADER;
  }

  return 'ready';
}

export const validateOtpDataFamilyWithChildrenRequest = (validatedCostumerData) => {
  if (!validatedCostumerData.subscriberExists) {
    return otpValidationPopupContent.isNotCellcomAccount;
  } else if (!validatedCostumerData.subStatusIsA) {
    return otpValidationPopupContent.subStatusIsA;
  } else if (!validatedCostumerData.dummySubIndIsNull) {
    return otpValidationPopupContent.dummySubIndIsNull;
  } else if (validatedCostumerData.notEligibleForFamily) {
    return otpValidationPopupContent.cantPurchasePackage;
  } else if (
    (!validatedCostumerData.sockRoamIsValid && validatedCostumerData.accountType == customerTypeEnum.BUSINESS) ||
    validatedCostumerData.noRoamSockExists
  ) {
    return otpValidationPopupContent.abroadIsClosedForAccount;
  } else if (validatedCostumerData.autoPackageExists) {
    if (validatedCostumerData.isSeparatedSale) {
      return otpValidationPopupContent.separatedSaleAutoPackage;
    } else {
      return otpValidationPopupContent.autoPackageExists;
    }
  } else if (validatedCostumerData.rollingPackageExists) {
    if (validatedCostumerData.isSeparatedSale) {
      return otpValidationPopupContent.separatedSaleRollingPackage;
    } else {
      return otpValidationPopupContent.rollingPackageExists;
    }
  } else if (!validatedCostumerData.accountTypeIsValid.item2) {
    let ans;
    switch (validatedCostumerData.accountTypeIsValid.item1) {
      case 'Talkman':
        ans = otpValidationPopupContent.talkmanAccount;
        break;
      case 'CantSaleNow':
        ans = otpValidationPopupContent.cantPurchasePackage;
        break;
      case 'CellcomWorker':
        ans = otpValidationPopupContent.isCellcomWorkerOtpSaleFamily;
        break;
      case 'GeneralError':
        ans = otpValidationPopupContent.otpGeneralError;
        break;

      default:
        ans = otpValidationPopupContent.cantPurchasePackage;
    }

    return ans;
  } else if (validatedCostumerData.accountTypeIsValid.item2 && validatedCostumerData.accountTypeIsValid.item1 == 'CellcomWorker') {
    return otpValidationPopupContent.isCellcomWorkerOtpLobby;
  } else {
    return null;
  }
};

const otpInitialState = {
  numOfAttempts: 0,
  wrongOtpMessage: '',
  showWrongOtpCodeMessage: false,
  otpPhone: '',
  validatedPhoneNumber: '',
  creationDate: '',
  deliveryType: '',
  step1Ticket: '',
  step2Validated: false,
  validatedCostumerData: {},
  isOTPValidated: false,
  isOtpValidatedPackageTab: false,
  otpPopupData: null,
  saleOTPStep: saleOTPSteps.MOBILE_INPUT,
  defaultSOC: null,
  readyToPurchase: false,
  isFamilyProcess: false,
  unqualifiedSubs: 0,
  otpSubscriberNotExist: false,
  restrictedCodeRequired: false,
};

const otpInitialPhoneForm = {
  phone: '',
  id: '',
  valid: '',
  errors: {
    phone: '',
  },
  rules: {},
};

const otpInitialCodeFormState = {
  verifyCode: '',
  valid: '',
  errors: {},
  restrictedCode: '',
  rules: {
    verifyCode: {
      required: {
        value: true,
        error: 'לא הוזן קוד',
      },
      minLength: {
        value: 6,
        error: 'יש להזין 6 תווים',
      },
      pattern: {
        value: regexPatterns.numbersRegex,
        error: 'ערך לא תקין',
      },
    },
  },
};

const initialDatesState = {
  selectedStartDate: '',
  selectedEndDate: '',
  datePickerStartJSFormat: null,
  datePickerEndJSFormat: null,
};

const initialBusinessIndividualState = {
  selfCareBlockUrl: '',
  selectedAccountNumber: '',
  isSelectingAccount: false,
  isFullFinancing: false,
  isSelectedAccountBelongsToSelectedHetPay: true,
  subStatusIsA: true,
  dummySubIndIsNull: true,
  popupData: '',
  closedForData: false,
  autoPackageExist: false,
  readyForPurchase: false,
  viewWithoutPurchaseStatus: false,
  allowIndependentFuturePurchases: false,
  fullFinancingOrSecurityLevelRed: false,
  buyPackageInSplit: null,
  isSwitching: false,
  isSplitAccount: false,
};

const initialFamilyPackageUsageDetails = {
  isPending: false,
  data: {},
  subscriberNameMap: {},
  subscribersWithNoApiData: [],
};

const initialState = {
  abroadInsurance: {
    error: '',
    data: {},
    currentSubscriber: '',
    showInsurance: false,
    needOTP: false,
  },
  abroadPermanentInsuranceSocData: {
    exist: false,
    isReady: false,
    socName: '',
    socSeqNo: '',
    effectiveDate: '',
    expirationDate: '',
    phoneNumber: '',
  },
  familyPackageUsageDetails: initialFamilyPackageUsageDetails,
  isLoading: false,
  termsIsLoading: true,
  customerAbroadPackagesRequestCompleted: false,
  customerAbroadPackages: {},
  customerAutoAbroadPackages: {},
  popularIsLoading: false,
  searchIsLoading: false,
  otpIsLoading: false,
  validateCustomerTypeRequestCompleted: false,
  generalLoader: false,
  statusRequest: '',
  error: false,
  page: pages.LOBBY,
  isBusiness: false,
  getEpiGeneralData: {},
  getAddonsPackage: {},
  epiStyleInitializationData: {
    lobbyBlockId: '',
    businessIndividualLobby: false,
    desktopTitle: '',
    mobileTitle: '',
    numberOfPackagesToShow: '',
    bannerURLSalePrivate: null,
    bannerImageSalePrivate: null,
    bannerURLSaleBusinessRegular: null,
    bannerImageSaleBusinessRegular: null,
    bannerURLSaleBusinessSeparation: null,
    bannerImageSaleBusinessSeparation: null,
    bannerURLSaleBusinessIndividual: null,
    bannerImageSaleBusinessIndividual: null,
    spacingBetweenSearchAndResultDataDesktop: '',
    spacingBetweenSearchAndResultDataMobile: '',
    listOfPrivatePopularSocIds: [],
    listOfBusinessPopularSocIds: [],
    businessSocPackageFolderId: '',
    goldBusinessSocPackageFolderId: '',
    privateSocPackageFolderId: '',
    addonsPackagesFolderId: '',
    lobbyBackgroundImageDesktop: '',
    lobbyBackgroundImageMobile: '',
    urlToDataUsageBlock: '',
    urlToSaleBlock: '',
    urlToSeparatedSale: '',
    currentLobbyPath: '',
    shouldDisplayPackageExists: null,
    pageRefToExtendedPackagesPrivate: '',
    pageRefToExtendedPackagesBusiness: '',
    abroadInsurancePage: '',
    abroadInsuranceLegalInfo: null,
    abroadInsuranceDesktopImage: null,
    abroadInsuranceMobileImage: null,
    abroadInsuranceButtonText: '',
    abroadInsuranceAllowed: '',
  },
  popularCountries: [],
  allCountries: [],
  supportedSocialMediaApplications: [],
  //otp
  otpPhoneForm: otpInitialPhoneForm,
  otpCodeForm: otpInitialCodeFormState,
  otpData: otpInitialState,
  otpDataChildren: otpInitialState,
  isJETAuthentication: false,
  relatedPhoneNumbers: [],
  relatedPhoneNumbersRequestCompleted: false,
  businessIndividualData: initialBusinessIndividualState,
  //popups
  isShowPopup: false,
  popupReason: '',
  //lobby tabs
  lobbyTabsButtons: [],
  activeLobbyTab: lobbyTabsEnum.PRIVATE,
  searchingMode: {
    status: false,
    searchParameter: '',
  },
  executePackagesSearch: false,
  //main data
  selectedAbroadPackage: null,
  boughtAbroadPackages: null,
  startedFromPackage: false,
  selectedOnSalePageFlag: false,
  selectedAbroadPackageFolderType: '',
  searchCountryResults: [],
  selectedCountries: [],
  selectedCountriesUsedInSearch: [],
  connectedToSelectedCountry: null,
  notSupportedCountries: null, //InSelectedPackage
  dates: initialDatesState,
  abroadPackagesPopular: [],
  abroadPackagesPopularMarket: [],
  abroadPackagesList: null,
  isRegularAbroadCustomer: true,
  //sale
  saleActiveStep: saleActiveStep.TICKET,
  businessIndividualActiveStep: businessIndividualSteps.LOADER,
  subscriberAbroadUsageData: null,
  removeToCustomerSurfingBlockage: false,
  completedWithCode: '',
  currentCountryDataToShow: '',
  userUsageData: {},
  userUsageDataCompleted: false,
  socPackageRemoveStatus: null,
  socPackageRemoveErrorCode: null,
  singleCountryUsageData: {},
  updatedSocResultStatus: null,
  chosenSocForAction: null,
  extendedPackageData: {},
  addedExtendedPackageResult: null,
  isUsageDataExists: false,
  isShowDataUsage: true,
  shadowPackagesNotToShowMessage: false,
  removedSurfSocResult: null,
  isSmallResolution: false,
  isPortrait: false,
  //separated sale
  shadowForm: {
    customerId: '',
    customerFirstName: '',
    customerLastName: '',
    customerEmail: '',
  },
  shadowCCInUpdate: false,
  shadowProcessStage: '',
  shadowClientBillData: null,
  shadowUpdatedCC: false,
  shadowCG: null,
  shadowNewFromExisting: false,

  familyPackageDetails: null,
  // Family Bundle State
  familyBundleData: {
    flightManager: null,
    selectedMembers: [],
    removedMembers: [],
    availableMembers: [],
    multipleBans: false,
    selectedBan: null,
    showMemberSelectionPopup: false,
    showFlightManagerTooltip: false,
    surfBlockedSubscriberPhones: [],
  },
  // Store purchased family bundle data for display in existing packages
  purchasedFamilyBundleData: null,
  comingFromPackageManager: false,
  isFromSuccess: false,
  abroadDataUsageStateKey: '',
  startedFromTracker: false,
  addonsAlreadyPurchased: [],
  screenAddonsPurchased: [],
  showAddonPopup: {show: false, addon: ''},
  //update or cancel package
  isCancelOrUpdatePackagePending: false,
  isCancelOrUpdatePackageIsCompletedSuccessfuly: false,
  coupon: {
    code: '',
    isValid: false,
    voucherAmount: 0,
    isLoading: false,
    error: '',
  },
};

const cellcomAbroadBlockSlice = createSlice({
  name: 'cellcomAbroad',
  initialState: initialState,
  reducers: {
    resetState: (state) => initialState,
    resetCoupon: (state) => {
      state.coupon = initialState.coupon;
    },
    setShadowFromExisting: (state, action) => {
      state.shadowNewFromExisting = action.payload;
      return state;
    },
    setBackupCG: (state, action) => {
      state.shadowCG = action.payload;
      return state;
    },
    setCurrentSubscriber: (state, action) => {
      state.abroadInsurance.currentSubscriber = action.payload;
      return state;
    },
    setNeedOtpInsurance: (state, action) => {
      state.abroadInsurance.needOTP = action.payload;
      return state;
    },
    eCommerceReportBuyRegularPackage: (state, action) => {
      return state;
    },
    eCommerceReportBuyFamilyPackage: (state, action) => {
      return state;
    },
    setDataUsageKey: (state, action) => {
      state.abroadDataUsageStateKey = action.payload;
      return state;
    },
    setUpdatedCC: (state, action) => {
      state.shadowUpdatedCC = action.payload;
      return state;
    },
    setNewPaymentShadow: (state, action) => {
      state.shadowClientBillData.paymentType = 'CC';
      state.shadowClientBillData.paymentData = action.payload;
      state.shadowClientBillData.shouldUpdate = false;
    },
    setFromSuccess: (state, action) => {
      state.isFromSuccess = action.payload;
    },
    setShadowFormData: (state, action) => {
      state.shadowForm = action.payload;
      return state;
    },
    setShadowProcessStage: (state, action) => {
      state.shadowProcessStage = action.payload;
      return state;
    },
    setShadowCCUpdateMode: (state, action) => {
      state.shadowCCInUpdate = action.payload;
      return state;
    },
    setPurchasedAddonsList: (state, action) => {
      state.addonsAlreadyPurchased = [...state.addonsAlreadyPurchased, action.payload];
      return state;
    },
    updateTicketFromPackageManager: (state, action) => {
      state.comingFromPackageManager = true;
      state.otpData.isFamilyProcess = true;
      state.otpData.socCodeParent = action.payload.socCodeParent;
      state.otpCodeForm = otpInitialCodeFormState;
      state.otpPhoneForm = otpInitialPhoneForm;
      state.otpDataChildren = {...otpInitialState, saleOTPStep: saleOTPSteps.SELECT_FAMILY_MEMBER};
      state.page = pages.SALE;
      state.selectedAbroadPackage = action.payload.selectedPackage;
      state.selectedAbroadPackageFolderType = action.payload ? action.payload.folderType : state.activeLobbyTab;
      // state.otpData.validatedCostumerData = {};
      state.otpData.validatedCostumerData.accountType = action.payload ? action.payload.folderType : state.activeLobbyTab;
      state.startedFromPackage = false;
      state.dates.selectedStartDate = action.payload.selectedStartDate;
      state.dates.datePickerStartJSFormat = action.payload.datePickerStartJSFormat;
      state.dates.selectedEndDate = getPackageEndDate(
        state.dates.datePickerStartJSFormat,
        state.selectedAbroadPackage.packageDuration,
      ).formattedUI;
      state.dates.datePickerEndJSFormat = getPackageEndDate(
        state.dates.datePickerStartJSFormat,
        state.selectedAbroadPackage.packageDuration,
      ).formattedISOS;
      state.selectedCountriesFamily = action.payload.countryList;
      state.fromPackageManagerToTicket = true;
      state.otpData.startDateParent = formatDatesToDifferentFormats(action.payload.parentStartDate).formattedProvider;
      state.otpData.endDateParent = getPackageEndDate(
        action.payload.parentStartDate,
        state.selectedAbroadPackage.packageDuration,
      ).formattedProvider;
      state.otpData.startDateParentJs = formatDatesToDifferentFormats(action.payload.parentStartDate).formattedISOS;
      state.otpData.endDateParentJs = getPackageEndDate(
        action.payload.parentStartDate,
        state.selectedAbroadPackage.packageDuration,
      ).formattedISOS;

      return state;
    },
    setComingFromPackageManager: (state, action) => {
      state.comingFromPackageManager = action.payload;
    },
    setCurrentCountryDataToShow: (state, action) => {
      state.currentCountryDataToShow = action.payload;
      return state;
    },
    setUpdatedSocResultStatus: (state, action) => {
      state.updatedSocResultStatus = action.payload;
      return state;
    },
    setChosenSocForAction: (state, action) => {
      state.chosenSocForAction = action.payload;
    },
    resetAddedExtendedPackageResult: (state, action) => {
      state.addedExtendedPackageResult = action.payload;
    },
    returnToLobby: (state, action) => {
      state.page = pages.LOBBY;
      state.selectedAbroadPackage = null;
      state.selectedAbroadPackageFolderType = '';
      state.startedFromPackage = false;
      state.selectedOnSalePageFlag = false;
      state.notSupportedCountries = null;
      state.abroadPackagesList = null;
      state.otpData.isFamilyProcess = false;
      state.otpDataChildren = otpInitialState;
      state.activeLobbyTab = action.payload?.activeTab ? action.payload.activeTab : lobbyTabsEnum.PACKAGEEXISTS;
      if (action.payload?.executePackagesSearch) {
        state.executePackagesSearch = !!(state.dates.selectedStartDate && state.selectedCountries?.length > 0);
      }
   
      if (action.payload?.approvedPopup) {
        state.otpData.approvedPopup = true;
      }
      state.isUsageDataExists = false;
      return state;
    },
    setRemovedSurfSocResult: (state, action) => {
      state.removedSurfSocResult = action.payload;
    },
    resetSocPackageRemoveStatus: (state, action) => {
      state.socPackageRemoveStatus = action.payload;
    },
    setLobbyTabsButtons: (state, action) => {
      state.lobbyTabsButtons = action.payload;
      return state;
    },
    epiStyleInitialization: (state, action) => {
      state.epiStyleInitializationData.abroadInsurancePage = action.payload.generalData.abroadInsurancePage?.value;
      state.epiStyleInitializationData.abroadInsuranceLegalInfo = action.payload.generalData.legalInfo?.value;
      state.epiStyleInitializationData.abroadInsuranceDesktopImage = action.payload.generalData.desktopImage?.expandedValue?.url;
      state.epiStyleInitializationData.abroadInsuranceMobileImage = action.payload.generalData.mobileImage?.expandedValue?.url;
      state.epiStyleInitializationData.abroadInsuranceButtonText = action.payload.generalData.buttonText?.value;
      state.epiStyleInitializationData.abroadInsuranceAllowed = action.payload.generalData.abroadInsuranceAllowed?.value;

      state.epiStyleInitializationData.lobbyBlockId = action.payload.generalData.contentLink?.id;
      state.epiStyleInitializationData.businessIndividualLobby = action.payload.generalData.isBusinessIndividualLobby.value;
      state.epiStyleInitializationData.desktopTitle = action.payload.generalData.desktopTitle?.value;
      state.epiStyleInitializationData.mobileTitle = action.payload.generalData.mobileTitle?.value;

      state.epiStyleInitializationData.bannerURLSalePrivate = action.payload.generalData.bannerURLSalePrivate?.value;
      state.epiStyleInitializationData.bannerImageSalePrivate = action.payload.generalData.bannerImageSalePrivate?.value;
      state.epiStyleInitializationData.bannerURLSaleBusinessRegular = action.payload.generalData.bannerURLSaleBusinessRegular?.value;
      state.epiStyleInitializationData.bannerImageSaleBusinessRegular = action.payload.generalData.bannerImageSaleBusinessRegular?.value;
      state.epiStyleInitializationData.bannerURLSaleBusinessIndividual = action.payload.generalData.bannerURLSaleBusinessIndividual?.value;
      state.epiStyleInitializationData.bannerImageSaleBusinessIndividual =
        action.payload.generalData.bannerImageSaleBusinessIndividual?.value;
      state.epiStyleInitializationData.bannerURLSaleBusinessSeparation = action.payload.generalData.bannerURLSaleBusinessSeparation?.value;
      state.epiStyleInitializationData.bannerImageSaleBusinessSeparation =
        action.payload.generalData.bannerImageSaleBusinessSeparation?.value;

      state.epiStyleInitializationData.spacingBetweenSearchAndResultDataDesktop =
        action.payload.generalData.spacingBetweenSearchAndResultDataDesktop?.value;
      state.epiStyleInitializationData.spacingBetweenSearchAndResultDataMobile =
        action.payload.generalData.spacingBetweenSearchAndResultDataMobile?.value;

      state.epiStyleInitializationData.lobbyBackgroundImageDesktop = action.payload.generalData.lobbyBackgroundImageDesktop?.value;
      state.epiStyleInitializationData.lobbyBackgroundImageMobile = action.payload.generalData.lobbyBackgroundImageMobile?.value;

      state.epiStyleInitializationData.businessSocPackageFolderId =
        action.payload.generalData.businessSocPackageFolder?.expandedValue?.contentLink?.id;
      state.epiStyleInitializationData.goldBusinessSocPackageFolderId =
        action.payload.generalData.goldBusinessSocPackageFolderId?.expandedValue?.contentLink?.id;

      state.epiStyleInitializationData.privateSocPackageFolderId =
        action.payload.generalData.privateSocPackageFolder?.expandedValue?.contentLink?.id;

      state.epiStyleInitializationData.listOfPrivatePopularSocIds = lodash.map(
        action.payload.generalData.popularPackagesToPrivate?.expandedValue,
        'sockCode.value',
      );
      state.epiStyleInitializationData.listOfBusinessPopularSocIds = lodash.map(
        action.payload.generalData.popularPackagesToBusiness?.expandedValue,
        'sockCode.value',
      );

      state.epiStyleInitializationData.urlToSaleBlock = action.payload.generalData.urlToSaleBlock?.expandedValue?.url;
      state.epiStyleInitializationData.urlToDataUsageBlock = action.payload.generalData.urlToDataUsageBlock?.expandedValue?.url;
      state.epiStyleInitializationData.urlToSeparatedSale = action.payload.generalData.pageReferenceToSeparatedSale?.value?.url;

      state.epiStyleInitializationData.currentLobbyPath = action.payload.currentPath;
      state.epiStyleInitializationData.shouldDisplayPackageExists = action.payload.generalData.shouldDisplayPackageExists?.value;
      state.epiStyleInitializationData.pageRefToExtendedPackagesPrivate =
        action.payload.generalData.pageRefToExtendedPackagesPrivate?.expandedValue?.url;
      state.epiStyleInitializationData.pageRefToExtendedPackagesBusiness =
        action.payload.generalData.pageRefToExtendedPackagesBusiness?.expandedValue?.url;
      state.epiStyleInitializationData.addonsPackagesFolderId =
        action.payload.generalData.pageRefToExtendedAddons?.expandedValue?.contentLink?.id;
    },
    setLoading: (state, action) => {
      state.generalLoader = action.payload;
    },
    setFlightManager: (state, action) => {
      state.familyBundleData.flightManager = action.payload;
      // Track intentional clears so auto-set doesn't overwrite them (even across remounts)
      state.familyBundleData.flightManagerCleared = action.payload === null;
    },
    setSelectedMembers: (state, action) => {
      state.familyBundleData.selectedMembers = action.payload;
    },
    setRemovedMembers: (state, action) => {
      state.familyBundleData.removedMembers = action.payload;
    },
    setBypassMemberValidation: (state, action) => {
      state.familyBundleData.bypassMemberValidation = action.payload;
    },
    setFamilyBundleErrorType: (state, action) => {
      state.familyBundleData.errorType = action.payload;
    },
    setFamilyBundleFailedMembers: (state, action) => {
      state.familyBundleData.failedMembers = action.payload;
    },
    setSurfBlockedSubscriberPhones: (state, action) => {
      state.familyBundleData.surfBlockedSubscriberPhones = action.payload || [];
    },
    toggleMemberSelection: (state, action) => {
      const memberId = action.payload;
      const index = state.familyBundleData.selectedMembers.findIndex((m) => m.id === memberId);
      if (index > -1) {
        state.familyBundleData.selectedMembers.splice(index, 1);
      } else {
        const member = state.familyBundleData.availableMembers.find((m) => m.id === memberId);
        if (member) {
          state.familyBundleData.selectedMembers.push(member);
        }
      }
    },
    setAvailableMembers: (state, action) => {
      state.familyBundleData.availableMembers = action.payload;
    },
    setMultipleBans: (state, action) => {
      state.familyBundleData.multipleBans = action.payload;
    },
    setSelectedBan: (state, action) => {
      state.familyBundleData.selectedBan = action.payload;
    },
    openMemberSelectionPopup: (state) => {
      state.familyBundleData.showMemberSelectionPopup = true;
    },
    closeMemberSelectionPopup: (state) => {
      state.familyBundleData.showMemberSelectionPopup = false;
    },
    toggleFlightManagerTooltip: (state, action) => {
      state.familyBundleData.showFlightManagerTooltip = action.payload;
    },
    savePurchasedFamilyBundleData: (state) => {
      // Save current family bundle data to purchasedFamilyBundleData before clearing
      if (state.familyBundleData.flightManager || state.familyBundleData.selectedMembers.length > 0) {
        state.purchasedFamilyBundleData = {
          flightManager: state.familyBundleData.flightManager,
          selectedMembers: [...state.familyBundleData.selectedMembers],
        };
      }
    },
    resetFamilyBundleData: (state) => {
      state.familyBundleData = {
        flightManager: null,
        flightManagerCleared: false,
        selectedMembers: [],
        removedMembers: [],
        availableMembers: [],
        multipleBans: false,
        selectedBan: null,
        showMemberSelectionPopup: false,
        showFlightManagerTooltip: false,
        surfBlockedSubscriberPhones: [],
      };
    },
    resetFamilyPackageUsageDetails: (state) => {
      state.familyPackageUsageDetails = initialFamilyPackageUsageDetails;
    },
    clearPurchasedFamilyBundleData: (state) => {
      state.purchasedFamilyBundleData = null;
    },
    setActiveLobbyTab: (state, action) => {
      state.activeLobbyTab = action.payload;
    },
    goToPage: (state, action) => {
      state.page = action.payload;
      return state;
    },
    setSaleActiveStep: (state, action) => {
      state.saleActiveStep = action.payload;
    },
    setIsRegularAbroadCustomer: (state, action) => {
      state.isRegularAbroadCustomer = action.payload;
    },

    onBlurHandler: {
      reducer(state, action) {
        state[action.payload.form] = action.payload.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);
        return {
          payload: {
            payload: validate,
            form: payload.formName,
          },
        };
      },
    },
    validatePhoneHandler: {
      reducer(state, action) {
        state.otpPhoneForm = action.payload;
      },
      prepare(payload) {
        const form = validateFields(lodash.cloneDeep(payload.form));
        if (!form.phone || form.phone.trim() === '') {
          form.errors.phone = 'יש להזין מספר טלפון';
        }
        if (!form.errors.phone) {
          form.valid = true;
        }
        return {
          payload: form,
        };
      },
    },
    validateOtpCodeHandler: {
      reducer(state, action) {
        state.otpCodeForm = action.payload;
      },
      prepare(payload) {
        const form = validateFields(lodash.cloneDeep(payload.form));
        return {
          payload: form,
        };
      },
    },
    changePhoneInputHandler: {
      reducer(state, action) {
        state.otpPhoneForm = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);
        const validate = validateField(form, name, value);

        if (form.phone.length > 10) {
          form.phone = form.phone.slice(0, 10);
          form.errors.phone = '';
        }

        let isNumber = /^\d+$/.test(form.phone);

        if (form.phone.length < 10 && isNumber) form.errors.phone = '';

        return {
          payload: validate,
        };
      },
    },
    changePhoneInputHandlerWithExtendedPhone: {
      reducer(state, action) {
        state.otpPhoneForm = action.payload;
      },
      prepare(payload) {
        const name = payload.target.name;
        const value = payload.target.value;
        const form = lodash.cloneDeep(payload.form);

        // Use PhoneExtended rules that accept both 05... and 130... (data-only) numbers
        form.rules = {phone: validationRules.PhoneExtended};
        const validate = validateField(form, name, value);

        if (form.phone.length > 10) {
          form.phone = form.phone.slice(0, 10);
          form.errors.phone = '';
        }

        let isNumber = /^\d+$/.test(form.phone);

        if (form.phone.length < 10 && isNumber) form.errors.phone = '';

        return {
          payload: validate,
        };
      },
    },
    setOtpVerifyCode: {
      reducer(state, action) {
        state.otpCodeForm.errors.verifyCode = '';
        if (action.payload.verifyCode == 'clear') state.otpCodeForm.verifyCode = '';
        else state.otpCodeForm.verifyCode = action.payload.verifyCode;
      },
    },
    clearOtpCode: {
      reducer(state, action) {
        state.form.verifyCode = action.payload.verifyCode;
        state.form.valid = '';
        state.form.isChange = false;
      },
    },
    clearOtpFormPhone: (state, action) => {
      state.otpPhoneForm.phone = '';
    },
    setOtpPhone: (state, action) => {
      state.otpData.otpPhone = action.payload;
    },
    setStartedFromTracker: (state, action) => {
      state.startedFromTracker = true;
      state.otpData.otpPhone = action.payload;
    },
    setChildrenOtpPhone: (state, action) => {
      state.otpDataChildren.otpPhone = action.payload;
    },

    setJETAuthentication: (state, action) => {
      state.otpData.otpPhone = action.payload;
      state.isJETAuthentication = true;
    },
    setIsSelectingAccountBusinessIndividual: (state, action) => {
      if (action.payload) {
        state.businessIndividualData.isSelectingAccount = action.payload.isSelecting;
        state.businessIndividualData.selectedAccountNumber = '';
        state.customerAbroadPackages = {};
        state.customerAbroadPackagesRequestCompleted = false;
        state.customerAutoAbroadPackages = {};
        state.isUsageDataExists = false;
        if (action.payload.abroadLobbyActiveStep) {
          state.page = action.payload.abroadLobbyActiveStep;
        }
        if (action.payload.removeSelectedAbroadPackage) {
          state.selectedAbroadPackage = null;
        }
      }
    },
    saveSelfCareBusinessIndividualBlockUrl: (state, action) => {
      state.businessIndividualData.selfCareBlockUrl = action.payload;
    },
    setBusinessIndividualActiveStep: (state, action) => {
      state.businessIndividualActiveStep = action.payload;
    },
    setViewWithoutPurchaseStatus: (state, action) => {
      state.businessIndividualData.viewWithoutPurchaseStatus = action.payload;
    },
    setOtpPopupData: (state, action) => {
      state.otpData.otpPopupData = action.payload;
    },
    removeOtpData: (state, action) => {
      state.otpCodeForm = otpInitialCodeFormState;
      state.otpPhoneForm = otpInitialPhoneForm;
      state.customerAbroadPackages = {};
      state.customerAbroadPackagesRequestCompleted = false;
      state.customerAutoAbroadPackages = {};
      state.subscriberAbroadUsageData = null;
      state.shadowForm = {
        customerId: '',
        customerFirstName: '',
        customerLastName: '',
        customerEmail: '',
      };
      state.shadowNewFromExisting = false;
      state.shadowCCInUpdate = false;
      state.shadowProcessStage = '';
      state.shadowClientBillData = null;
      state.userUsageData = {};
      state.userUsageDataCompleted = false;
      state.isUsageDataExists = false;
      state.relatedPhoneNumbers = [];
      state.validateCustomerTypeRequestCompleted = false;
      state.relatedPhoneNumbersRequestCompleted = false;
      if (state.otpData.validatedCostumerData?.isSeparatedSale) {
        state.selectedAbroadPackage = null;
      }
      if (state.selectedAbroadPackage?.isFamilyBonus) {
        state.otpDataChildren = otpInitialState;
      } else {
        state.otpData = otpInitialState;
      }
      if (state.abroadDataUsageStateKey?.trim()) {
        removeItem(state.abroadDataUsageStateKey);
        state.abroadDataUsageStateKey = '';
      }
      removeItem('abroadOTP');
      AuthenticationProvider.clearAuthenticationData();
      return state;
    },
    removeOtpDataChildren: (state, action) => {
      state.otpDataChildren = otpInitialState;
      state.otpCodeForm = otpInitialCodeFormState;
      state.otpPhoneForm = otpInitialPhoneForm;
      return state;
    },
    clearBusinessIndividualDataOnSelecthetPay: (state, action) => {
      state.otpPhoneForm = otpInitialPhoneForm;
      state.customerAbroadPackages = {};
      state.customerAbroadPackagesRequestCompleted = false;
      state.customerAutoAbroadPackages = {};
      state.subscriberAbroadUsageData = null;
      state.businessIndividualData = initialBusinessIndividualState;
    },
    clearBusinessIndividualSelectedAccountError: (state, action) => {
      state.businessIndividualData.isSelectedAccountBelongsToSelectedHetPay = true;
      state.businessIndividualData.subStatusIsA = true;
      state.businessIndividualData.dummySubIndIsNull = true;
    },
    setSaleOtpStep: (state, action) => {
      state.otpData.saleOTPStep = action.payload;
    },

    setSaleOtpChildrenStep: (state, action) => {
      state.otpDataChildren.saleOTPStep = action.payload;
    },

    setBuyPackageInSplit: (state, action) => {
      state.businessIndividualData.buyPackageInSplit = action.payload;
    },
    setSwitchingAccount: (state, action) => {
      state.businessIndividualData.isSwitching = action.payload;
    },

    hideOtpErrorMessage: (state, action) => {
      return {
        ...state,
        otpData: {
          ...state.otpData,
          showWrongOtpCodeMessage: false,
        },
      };
    },
    hideOtpChildrenErrorMessage: (state, action) => {
      return {
        ...state,
        otpData: {
          ...state.otpData,
          showWrongOtpCodeMessage: false,
        },
      };
    },
    setSearchingMode: (state, action) => {
      if (action.payload) {
        selectParametersGAReport({
          activeLobbyTab: state.activeLobbyTab,
          searchParameter: action.payload,
          startedFromPackage: state.startedFromPackage,
          isSeparatedSale: state.otpData.validatedCostumerData?.isSeparatedSale,
          isBusinessIndividual: state.epiStyleInitializationData.businessIndividualLobby,
          selectedPackage: state.selectedAbroadPackage,
        });
      }

      let searchStatus = action.payload ? true : false;
      state.searchingMode.status = searchStatus;
      state.searchingMode.searchParameter = action.payload;
    },
    saveSelectedCountry: (state, action) => {
      if (!state.selectedCountries.some((existsCountry) => existsCountry.countryCode == action.payload.countryCode)) {
        return {
          ...state,
          selectedCountries: [...state.selectedCountries, action.payload],
        };
      }
      return {
        ...state,
      };
    },
    saveSelectedCountries: (state, action) => {
      state.selectedCountries = [...state.selectedCountries, ...action.payload];
      return state;
    },
    saveSelectedCountriesUsedInSearch: (state, action) => {
      state.selectedCountriesUsedInSearch = action.payload;
      return state;
    },
    saveNotSupportedCountries: (state, action) => {
      return {
        ...state,
        notSupportedCountries: action.payload,
      };
    },
    setConnectedToSelectedCountry: (state, action) => {
      return {
        ...state,
        connectedToSelectedCountry: action.payload,
      };
    },
    setSearchCountryResults: (state, action) => {
      return {
        ...state,
        searchCountryResults: action.payload,
      };
    },
    saveSelectedStartDate: (state, action) => {
      state.dates.selectedStartDate = action.payload.selectedStartDate;
      state.dates.datePickerStartJSFormat = action.payload.datePickerStartJSFormat;
      state.dates.isQueryParamStartDate = action.payload.isQueryParam || false;
      return state;
    },
    saveSelectedEndDate: (state, action) => {
      state.dates.selectedEndDate = action.payload.selectedEndDate;
      state.dates.datePickerEndJSFormat = action.payload.datePickerEndJSFormat;
      state.dates.isQueryParamEndDate = action.payload.isQueryParam || false;
      return state;
    },
    removeFromSelectedCountries: (state, action) => {
      const newData = state.selectedCountries.filter((country, i) => country.countryHebName !== action.payload.countryHebName);
      return {
        ...state,
        selectedCountries: newData,
      };
    },
    clearSearchParameters: (state, action) => {
      state.selectedCountries = [];
      state.dates = initialDatesState;
      state.abroadPackagesList = null;
    },
    setSelectedAbroadPackage: (state, action) => {
      state.selectedAbroadPackage = action.payload ? action.payload.selectedPackage : null; // entire package object
      state.selectedAbroadPackageFolderType = action.payload ? action.payload.folderType : state.activeLobbyTab; // string private / business
      state.startedFromPackage = action.payload ? action.payload.startedFromPackage : false;
      state.selectedOnSalePageFlag = action.payload ? action.payload.selectedOnSalePageFlag : false;
      state.otpData.isFamilyProcess = false;
      if (action.payload) {
        //DWH
        const {channel, subscriber, param1, param3, param4, param5, param6, param7} = getDwhParams(state);
        const param2 = action.payload.selectedPackage.socCode;
        dwhSetSelectedAbroadPackage({
          channel,
          subscriber,
          param1,
          param2,
          param4,
          param3,
          param5,
          param6,
          param7,
        });
      }
    },
    clearScreenILAddon: (state, action) => {
      state.CouponAddons = [];
      state.screenAddonsPurchased = [];
      return state;
    },
    setShowAddonPopup: (state, action) => {
      state.showAddonPopup.show = action.payload.show;
      state.showAddonPopup.addon = action.payload.addon;
      if (!action.payload.show) {
        let el = document.getElementsByTagName('body')[0];
        el.classList.remove('modal-open');
      }
      return state;
    },
    clearSelectedAbroadPackage: (state, action) => {
      state.selectedAbroadPackage = null;
      state.startedFromPackage = false;
      state.executePackagesSearch =
        state.dates.selectedStartDate && state.selectedCountries?.length > 0 && state.activeLobbyTab != lobbyTabsEnum.PACKAGEEXISTS;
    },
    setSelectedFromSalePageFlag: (state, action) => {
      state.selectedOnSalePageFlag = action.payload;
    },
    setSearchedPackages: (state, action) => {
      state.abroadPackagesList = action.payload;
    },
    setReadyToPurchaseForBusinessIndividualAndSetAllowIndependentFuturePurchases: (state, action) => {
      state.businessIndividualData.readyForPurchase = true;
      state.businessIndividualData.allowIndependentFuturePurchases = action.payload;
      state.isShowPopup = false;
    },
    setRemoveToCustomerSurfingBlockage: (state, action) => {
      state.removeToCustomerSurfingBlockage = true;

      if (state.epiStyleInitializationData.businessIndividualLobby) {
        state.businessIndividualData.readyForPurchase = true;
        return state;
      }

      if (!state.otpData?.isFamilyProcess) state.otpData.readyToPurchase = true;
      else {
        state.otpDataChildren.removeToCustomerSurfingBlockage = true;
        state.otpDataChildren.readyToPurchase = true;
      }
    },
    setAllowedToAbroadLobby: (state, action) => {
      state.businessIndividualData.allowedToAbroadLobby = action.payload;
    },
    setReadyToPurchase: (state, action) => {
      if (state.epiStyleInitializationData.businessIndividualLobby) {
        state.businessIndividualData.readyForPurchase = action.payload;
      } else {
        state.otpData.readyToPurchase = action.payload;
      }
    },
    setReadyToPurchaseFamily: (state, action) => {
      state.otpDataChildren.readyToPurchase = action.payload;
    },
    finalizeFamilyBundleInstallValidation: (state, action) => {
      const {primaryResult, validatedPhone} = action.payload;
      applyAbroadRetrieveResultToState(state, primaryResult, {validatedPhone, keepLoaderStep: true});
    },
    openModal: (state, action) => {
      state.isShowPopup = true;
      state.popupReason = action.payload;
    },

    closeModal: (state, action) => {
      let reportParams = getReportParams();
      reportParams.area = 'SelfCare';
      reportParams.subArea = 'Cellcom Abroad';
      reportParams.param1 = state.isJETAuthentication ? 'JET' : 'WEBSITE';
      reportParams.subscriber = state.otpDataChildren.otpPhone
        ? state.otpDataChildren.otpPhone
        : state.otpData.otpPhone
        ? state.otpData.otpPhone
        : '';
      if (state.selectedAbroadPackage?.isFamilyBonus) {
        reportParams.param3 = 'בני משפחות';
        reportParams.param4 = 'מספר מנוי ראשי - ' + state.otpData.otpPhone;
      } else if (state.otpData.validatedCostumerData?.isSeparatedSale) {
        reportParams.param3 = 'מכר בהפרדה';
      }
      switch (state.otpData.otpPopupData?.id) {
        case 'isBusinessAccount':
          reportParams.channel = 'WebsitePrivate';
          reportParams.actionType = 'Business move';
          reportParams.status = 'Ongoing';
          reportParams.messageText = 'Moved to a business package';
          report(reportParams);
          break;
        case 'isPrivateAccount':
          reportParams.channel = 'WebsiteBusiness';
          reportParams.actionType = 'Private move';
          reportParams.status = 'Ongoing';
          reportParams.messageText = 'Moved to a private package';
          report(reportParams);
          break;
        case 'isCellcomWorkerOtpSale':
        case 'isCellcomWorkerOtpLobby':
          reportParams.channel = 'WebsitePrivate';
          reportParams.actionType = 'Cellcom worker move';
          reportParams.status = 'Ongoing';
          reportParams.messageText = 'Went to Cellcom worker packages';
          report(reportParams);
          break;
      }

      // If closing a family-bundle related popup, clear transient error details
      const familyBundlePopupReasons = [
        popupReasonEnum.FAMILY_BUNDLE_FLIGHT_MANAGER_ERROR,
        popupReasonEnum.FAMILY_BUNDLE_FLIGHT_MEMBERS_ERROR,
        popupReasonEnum.FAMILY_BUNDLE_CELLULAR_DATA_OFF,
      ];
      if (familyBundlePopupReasons.includes(state.popupReason)) {
        state.familyBundleData = {
          ...(state.familyBundleData || {}),
          errorType: null,
          failedMembers: [],
        };
      }
      if (state.popupReason === popupReasonEnum.DATA_USAGE_IS_BLOCKED) {
        state.familyBundleData.surfBlockedSubscriberPhones = [];
      }
      state.isShowPopup = false;
      state.popupReason = '';
      if (action.payload?.isDefaultSocFromFamily) {
        state.saleActiveStep = saleActiveStep.TICKET;
        state.otpPhoneForm.phone = '';
        state.otpPhoneForm.valid = false;
        state.otpCodeForm.verifyCode = '';
        state.otpCodeForm.valid = false;
        state.otpDataChildren = otpInitialState;
      }
      return state;
    },

    saveToHistory: (state, action) => {
      return state;
    },
    clearHistory: (state, action) => {
      return state;
    },
    setSmallResolution: (state, action) => {
      state.isSmallResolution = action.payload;
    },
    setIsPortrait: (state, action) => {
      state.isPortrait = action.payload;
    },
    removeStateFromHistoryAction: (state, action) => {
      return state;
    },
    readyToPurchasePackageFamily: (state, action) => {
      state.otpDataChildren.readyToPurchase = true;
      return state;
    },
    goToFamily: (state, action) => {
      state.saleActiveStep = saleActiveStep.TICKET;
      state.otpPhoneForm.phone = '';
      state.otpPhoneForm.valid = false;
      state.otpCodeForm.verifyCode = '';
      state.otpCodeForm.valid = false;
      state.otpDataChildren = otpInitialState;
      return state;
    },
    displayRestrictedCodePopup: (state, action) => {
      state.isShowPopup = true;
      state.isRestrictedCodePopUpFromTicket = action.payload;
      state.popupReason = popupReasonEnum.RESTRICTED_CODE_REQUIRED;
      return state;
    },
    setRestrictedCode: (state, action) => {
      state.otpCodeForm.restrictedCode = action.payload;
    },
    setOtpIsLoading: (state, action) => {
      state.otpIsLoading = action.payload;
    },
    setIsOtpStep2Validated: (state, action) => {
      state.otpData.step2Validated = true;
      state.otpData.saleOTPStep = saleOTPSteps.STEP_2_VALIDATED;
    },
    removeFromBoughtPackages: (state, action) => {
      state.boughtAbroadPackages.splice(action.payload, 1);
    },
    filterCustomerFromBoughtPackages: (state, action) => {
      state.boughtAbroadPackages = state.boughtAbroadPackages.filter((item) => item.customerPhone !== action.payload);
    },
    clearOtpForm: (state, action) => {
      state.otpCodeForm = otpInitialCodeFormState;
      state.otpPhoneForm = otpInitialPhoneForm;
      state.otpData.step1Ticket = '';
      state.otpData.saleOTPStep = saleOTPSteps.MOBILE_INPUT;
    },
    setAbroadCoupon: (state, action) => {
      state.coupon = action.payload;
    },
  },
  extraReducers: {
    [GetAbroadAdditionalServices.fulfilled]: (state, action) => {
      if (!action.payload?.error) {
        let socInfo = action.payload?.data.Body;
        let insuranceInfo = socInfo?.abroadInsurance;
        let couponAddons = socInfo?.couponAddons;
        if (insuranceInfo?.permanentInsurance != null) {
          state.abroadPermanentInsuranceSocData.exist = true;
          state.abroadPermanentInsuranceSocData.socName = insuranceInfo?.permanentInsurance?.socName;
          state.abroadPermanentInsuranceSocData.socSeqNo = insuranceInfo?.permanentInsurance?.socSeqNo;
          state.abroadPermanentInsuranceSocData.effectiveDate = insuranceInfo?.permanentInsurance?.effectiveDate;
          state.abroadPermanentInsuranceSocData.expirationDate = insuranceInfo?.permanentInsurance?.expirationDate;
          state.abroadPermanentInsuranceSocData.phoneNumber = insuranceInfo?.phoneNumber;
        }
        if (couponAddons != null) {
          state.couponAddons = couponAddons;
        }
      }
      if (state.abroadPermanentInsuranceSocData.exist) {
        state.abroadInsurance.showInsurance = false;
      } else {
        state.abroadInsurance.showInsurance = true;
      }
      state.abroadPermanentInsuranceSocData.isReady = true;
    },
    [GetCollaborationInsuranceData.fulfilled]: (state, action) => {
      if (!action.payload?.error) {
        let socInfo = action.payload?.data.Body;
        if (socInfo?.permanentInsurance != null) {
          state.abroadPermanentInsuranceSocData.exist = true;
          state.abroadPermanentInsuranceSocData.socName = socInfo?.permanentInsurance?.socName;
          state.abroadPermanentInsuranceSocData.socSeqNo = socInfo?.permanentInsurance?.socSeqNo;
          state.abroadPermanentInsuranceSocData.effectiveDate = socInfo?.permanentInsurance?.effectiveDate;
          state.abroadPermanentInsuranceSocData.expirationDate = socInfo?.permanentInsurance?.expirationDate;
          state.abroadPermanentInsuranceSocData.phoneNumber = socInfo?.phoneNumber;
        }
      }
      if (state.abroadPermanentInsuranceSocData.exist) {
        state.abroadInsurance.showInsurance = false;
      } else {
        state.abroadInsurance.showInsurance = true;
      }
      state.abroadPermanentInsuranceSocData.isReady = true;
    },
    [FetchFamilyBundleUsages.pending]: (state) => {
      state.familyPackageUsageDetails.isPending = true;
    },
    [FetchFamilyBundleUsages.fulfilled]: (state, action) => {
      state.familyPackageUsageDetails.isPending = false;
      const {data, subscriber, subsDataArr} = action.payload || {};
      const {statusCode, subscribersUsageData} = data?.Body || {};

      if (statusCode !== FamilyBundleStatus.Success) {
        if (statusCode !== FamilyBundleStatus.GeneralError) {
          if (subscriber) {
            state.familyPackageUsageDetails.subscribersWithNoApiData.push(subscriber);
          }
          state.familyPackageUsageDetails.data = {};
        }
        return;
      }

      Object.entries(subscribersUsageData).forEach(([subscriberNo, socData]) => {
        if (!state.familyPackageUsageDetails.data?.[subscriberNo]) {
          state.familyPackageUsageDetails.data[subscriberNo] = socData;
        } else {
          Object.assign(state.familyPackageUsageDetails.data?.[subscriberNo], socData);
        }
      });

      if (Object.keys(state.familyPackageUsageDetails.subscriberNameMap).length === 0 && subsDataArr?.length > 0) {
        state.familyPackageUsageDetails.subscriberNameMap = Object.fromEntries(
          subsDataArr.map((item) => [item.productSubscriberNo, item.productFirstName]),
        );
      }
    },
    [FetchFamilyBundleUsages.rejected]: (state, action) => {
      state.familyPackageUsageDetails.isPending = false;
      const {subscriber} = action.payload || {};
      if (subscriber) {
        state.familyPackageUsageDetails.subscribersWithNoApiData.push(subscriber);
      }
      state.familyPackageUsageDetails.data = {};
    },
    [PostCollaborationInsurance.fulfilled]: (state, action) => {
      state.abroadInsurance.error = action.payload?.error;
      state.abroadInsurance.data = action.payload?.data;
    },
    [UpdateShadowClientCard.pending]: (state, action) => {
      state.isLoading = true;
    },
    [UpdateShadowClientCard.fulfilled]: (state, action) => {
      state.isLoading = false;
    },
    [UpdateEmailOfCustomer.pending]: (state, action) => {
      state.isLoading = true;
    },
    [UpdateEmailOfCustomer.fulfilled]: (state, action) => {
      if (action.payload.Body?.wasSuccessful) {
        state.shadowClientBillData.billingType = 'Email';
        state.shadowClientBillData.billingAddressData = action.meta.arg.email;
      }
      state.isLoading = false;
    },
    [getUnqualifiedSubsFamily.fulfilled]: (state, action) => {
      state.otpData.unqualifiedSubs = action.payload.response;
    },
    [getUnqualifiedSubsFamily.pending]: (state, action) => {
      state.saleActiveStep = saleActiveStep.LOADER;
    },
    [getAbroadFamilyPackageDetails.fulfilled]: (state, action) => {
      if (action.payload.childrenIsFull) {
        state.saleActiveStep = saleActiveStep.COMPLETED_SUCCESSFUL;
        return state;
      } else if (action.payload.alreadyInFamilyProcess) {
      } else {
        const startDateParent = formatDatesToDifferentFormats(state.dates.datePickerStartJSFormat).formattedProvider;
        const endDateParent = getPackageEndDate(
          state.dates.datePickerStartJSFormat,
          state.selectedAbroadPackage.packageDuration,
        ).formattedProvider;
        state.otpData.startDateParent = startDateParent;
        state.otpData.endDateParent = endDateParent;
        state.otpData.startDateParentJs = formatDatesToDifferentFormats(state.dates.datePickerStartJSFormat).formattedISOS;
        state.otpData.endDateParentJs = getPackageEndDate(
          state.dates.datePickerStartJSFormat,
          state.selectedAbroadPackage.packageDuration,
        ).formattedISOS;
        state.familyPackageDetails = action.payload.Body;
        state.selectedAbroadPackage = action.payload.Body;
        state.saleActiveStep = saleActiveStep.TICKET;
        state.otpPhoneForm = otpInitialPhoneForm;
        state.otpCodeForm = otpInitialCodeFormState;
        state.otpData.isFamilyProcess = true;
      }
      return state;
    },
    [GetShadowClientBillData.pending]: (state, action) => {
      state.isLoading = true;
      return state;
    },
    [GetShadowClientBillData.fulfilled]: (state, action) => {
      state.shadowClientBillData = action.payload.Body;
      state.isLoading = false;
      return state;
    },
    [abroadAddSoc.fulfilled]: (state, action) => {
      state.addedExtendedPackageResult = action.payload.Body.isSuccess;
      return state;
    },
    [getExtendedPackageData.fulfilled]: (state, action) => {
      if (action.payload?.Header?.ReturnCode == 0) {
        state.extendedPackageData = action.payload.Body;
        return state;
      } else {
        return state;
      }
    },

    [removePackage.fulfilled]: (state, action) => {
      if (action.payload?.Header?.ReturnCode == '0') {
        if (state.activeLobbyTab == lobbyTabsEnum.PACKAGEEXISTS_BUSINESSINDIVIDUAL) {
          selfServiceDwh.AbroadPackage.Remove(state);
        }
        state.removedSurfSocResult = action.payload.shouldRemoveSurfingBlockSoc;
        state.socPackageRemoveStatus = action.payload.Body.isSuccess;
        state.socPackageRemoveErrorCode = action.payload.Body.codeError || null;
        state.isCancelOrUpdatePackageIsCompletedSuccessfuly = true;
      } else {
        state.removedSurfSocResult = false;
        state.socPackageRemoveStatus = false;
        state.socPackageRemoveErrorCode = null;
        state.isCancelOrUpdatePackageIsCompletedSuccessfuly = false;
      }
      state.isCancelOrUpdatePackagePending = false;
      return state;
    },
    [removePackage.pending]: (state, action) => {
      state.isCancelOrUpdatePackagePending = true;
      state.isCancelOrUpdatePackageIsCompletedSuccessfuly = false;
      state.socPackageRemoveErrorCode = null;
      return state;
    },
    [removePackage.rejected]: (state, action) => {
      state.socPackageRemoveStatus = false;
      state.socPackageRemoveErrorCode = null;
      state.isCancelOrUpdatePackagePending = false;
      state.isCancelOrUpdatePackageIsCompletedSuccessfuly = false;
      return state;
    },
    [removeCapSoc.pending]: (state, action) => {
      state.popupReason = popupReasonEnum.CAP_SOC_REMOVE_PROCESSING;
      state.popupData = otpValidationPopupContent.removeCapSocProcessLoading;
    },
    [removeCapSoc.fulfilled]: (state, action) => {
      if (action.payload?.result?.Header?.ReturnCode != '0' || action.payload.error || !action.payload.result.Body?.isSuccess) {
        state.popupData = otpValidationPopupContent.removeCapSocProcessError;
      } else {
        state.popupData = otpValidationPopupContent.removeCapSocProcessSuccess;
      }
      return state;
    },
    [getRetrieveTariffPrices.pending]: (state, action) => {
      state.singleCountryUsageData = 'Pending';
      return state;
    },
    [updatePackage.fulfilled]: (state, action) => {
      state.updatedSocResultStatus = action.payload.Body.isSuccess;
      if (action.payload.Body.isSuccess) {
        if (state.activeLobbyTab == lobbyTabsEnum.PACKAGEEXISTS_BUSINESSINDIVIDUAL) {
          selfServiceDwh.AbroadPackage.Update(state);
        }
      }
      state.isCancelOrUpdatePackagePending = false;
      state.isCancelOrUpdatePackageIsCompletedSuccessfuly = true;
      return state;
    },
    [updatePackage.pending]: (state, action) => {
      state.isCancelOrUpdatePackagePending = true;
      state.isCancelOrUpdatePackageIsCompletedSuccessfuly = false;
      return state;
    },
    [updatePackage.rejected]: (state, action) => {
      state.updatedSocResultStatus = false;
      state.isCancelOrUpdatePackagePending = false;
      state.isCancelOrUpdatePackageIsCompletedSuccessfuly = false;
      return state;
    },
    [getRetrieveTariffPrices.fulfilled]: (state, action) => {
      state.singleCountryUsageData = action.payload.Body;
      return state;
    },
    [getCustomerAbroadUsageDisplay.pending]: (state, action) => {
      state.userUsageData = 'Pending';
      return state;
    },
    [getCustomerAbroadUsageDisplay.fulfilled]: (state, action) => {
      if (!action.payload.error) {
        if (action.payload.Body.accountSegment == 'GeneralError') {
          let ans = otpValidationPopupContent.otpGeneralError;
          state.otpData.otpPopupData = ans;
          state.isShowPopup = true;
          state.popupReason = popupReasonEnum.OTP_RESULT;
          state.userUsageData = {};
          return state;
        }
        state.userUsageData = action.payload.Body;
        state.userUsageDataCompleted = true;
        state.otpData.validatedCostumerData.accountType = action.payload.Body?.userType;
      } else {
        state.userUsageData = 'error';
      }
      return state;
    },
    [getCustomerAbroadPackages.pending]: (state, action) => {
      state.otpData.isOtpValidatedPackageTab = false;
      state.customerAbroadPackages = 'Pending';
      state.customerAbroadPackagesRequestCompleted = false;
      state.customerAutoAbroadPackages = {};
      state.generalLoader = true;
      state.isUsageDataExists = false;
      return state;
    },
    [getCustomerAbroadPackages.fulfilled]: (state, action) => {
      state.generalLoader = false;
      state.startedFromTracker = false;
      let ans;
      if (action.payload.error) {
        if (action.payload.reason.errorCode == 99) {
          ans = otpValidationPopupContent.otpGeneralError;
        } else if (action.payload.reason.errorCode == 95) {
          ans = otpValidationPopupContent.isNotCellcomAccount;
        } else {
          ans = otpValidationPopupContent.otpGeneralError;
        }
        state.customerAbroadPackages = 'error';
      } else {
        if (action.payload?.result?.Body?.item1 == null && action.payload?.result?.Body?.item3 == false) {
          if (action.payload?.result?.Body?.item2 == 'NotCellcomUser') {
            ans = otpValidationPopupContent.isNotCellcomAccount;
          } else {
            ans = otpValidationPopupContent.cantPurchasePackage;
          }
          state.customerAbroadPackages = 'error';
        } else {
          ans = null;
          state.otpData.otpPopupData = null;
          state.isShowPopup = false;
          state.popupReason = '';
        }
      }

      if (ans) {
        state.otpData.otpPopupData = ans;
        state.isShowPopup = true;
        state.popupReason = popupReasonEnum.OTP_RESULT;
        return state;
      }

      state.otpData.isOtpValidatedPackageTab = true;
      if (action.payload.result.Body.item1.length > 0) {
        state.customerAbroadPackages = lodash.filter(action.payload.result.Body.item1, function (pack) {
          if (!pack.isAutoPackage) {
            return pack;
          }
        });
        state.customerAutoAbroadPackages = lodash.filter(action.payload.result.Body.item1, function (pack) {
          if (pack.isAutoPackage) {
            return pack;
          }
        });
      } else {
        state.customerAbroadPackages = [];
      }
      state.otpIsLoading = false;
      state.isUsageDataExists = true;
      if (!state.isJETAuthentication) {
        const storeData = {validatedPhone: action.payload.validatedPhone};
        setItem('abroadOTP', storeData, true);
      }
      state.customerAbroadPackagesRequestCompleted = true;
      return state;
    },

    [getCustomerAbroadPackagesBusinessIndividual.pending]: (state, action) => {
      state.otpData.isOtpValidatedPackageTab = false;
      state.customerAbroadPackagesRequestCompleted = false;
      return state;
    },
    [getCustomerAbroadPackagesBusinessIndividual.fulfilled]: (state, action) => {
      let ans;
      state.customerAbroadPackagesRequestCompleted = true;
      if (action.payload.error || (action.payload?.Body?.item1 == null && action.payload?.Body?.item3 == false)) {
        ans = otpValidationPopupContent.basicGeneralError;
        state.customerAbroadPackages = action.payload?.Body?.item2;
      }

      if (ans) {
        state.otpData.otpPopupData = ans;
        state.isShowPopup = true;
        state.popupReason = popupReasonEnum.OTP_RESULT;
        return state;
      }
      state.otpData.isOtpValidatedPackageTab = true;
      state.isShowDataUsage = action.payload?.Body?.item3;
      state.shadowPackagesNotToShowMessage = action.payload?.Body?.item4;

      if (action.payload.Body.item1.length > 0) {
        state.customerAbroadPackages = lodash.filter(action.payload.Body.item1, function (pack) {
          if (!pack.isAutoPackage) {
            return pack;
          }
        });
        state.customerAutoAbroadPackages = lodash.filter(action.payload.Body.item1, function (pack) {
          if (pack.isAutoPackage) {
            return pack;
          }
        });
      } else {
        state.customerAbroadPackages = [];
      }

      state.isUsageDataExists = true;

      return state;
    },
    [getUsageData.fulfilled]: (state, action) => {
      return {
        ...state,
        subscriberAbroadUsageData: action.payload.Body,
      };
    },
    [getEpiGeneralData.fulfilled]: (state, action) => {
      if (!action.payload.error) {
        state.getEpiGeneralData = action.payload.data;
        state.popularCountries = action.payload.data.popularCountries;
        state.allCountries = action.payload.data.allCountries;
        state.supportedSocialMediaApplications = action.payload.data.supportedApps;
        state.epiStyleInitializationData.numberOfPackagesToShow = action.payload.data.numberOfPackagesToShow;
      }
      return state;
    },
    [getAddonsPackage.fulfilled]: (state, action) => {
      state.statusRequest = 'completed';
      var addonResult = action.payload.Body;
      return state;
    },
    [abroadCountriesSearched.pending]: (state, action) => {
      state.statusRequest = 'pending';
      return state;
    },
    [abroadCountriesSearched.fulfilled]: (state, action) => {
      if (!action.payload.error) {
        state.searchCountryResults = action.payload.data;
      }
      state.statusRequest = 'completed';
      return state;
    },
    [verifyPhone.pending]: (state, action) => {
      if (state.page == pages.SALE) {
        if (state.selectedAbroadPackage?.isFamilyBonus) state.otpDataChildren.saleOTPStep = saleOTPSteps.LOADER;
        else state.otpData.saleOTPStep = saleOTPSteps.LOADER;
      } else {
        state.otpIsLoading = true;
      }
    },
    [verifyPhone.fulfilled]: (state, action) => {
      state.otpIsLoading = false;
      if (state.selectedAbroadPackage?.isFamilyBonus) {
        if (!action.payload.error && action.payload.result.step1Ticket) {
          state.otpDataChildren.creationDate = action.payload.result.creationDate;
          state.otpDataChildren.deliveryType = action.payload.result.deliveryType;
          state.otpDataChildren.step1Ticket = action.payload.result.step1Ticket;
          state.otpDataChildren.otpPhone = action.payload.otpPhone;
          if (state.page == pages.SALE) {
            state.otpDataChildren.saleOTPStep = saleOTPSteps.OTP;
          }
          state.restrictedCodeRequired = action.payload.result.restrictedCodeRequired;
          return state;
        }

        //error
        //DWH family
        errorOnOTPStep1(state.otpPhoneForm.phone, 'בני משפחה');

        state.otpDataChildren.otpPopupData = otpValidationPopupContent.otpGeneralError;
        state.isShowPopup = true;
        state.popupReason = popupReasonEnum.OTP_RESULT;
        state.otpDataChildren.step1Error = true;
        return state;
      } else {
        if (!action.payload.error && action.payload.result.step1Ticket) {
          state.otpData.creationDate = action.payload.result.creationDate;
          state.otpData.deliveryType = action.payload.result.deliveryType;
          state.otpData.step1Ticket = action.payload.result.step1Ticket;
          state.otpData.otpPhone = action.payload.otpPhone;
          if (state.page == pages.SALE) {
            state.otpData.saleOTPStep = saleOTPSteps.OTP;
          }
          state.restrictedCodeRequired = action.payload.result.restrictedCodeRequired;
          return state;
        }
        //error DWH
        let param3 = 'פרטי';
        if (state.activeLobbyTab == lobbyTabsEnum.BUSINESSACCOUNT && state.page != pages.SALE) {
          param3 = 'עסקי';
        } else if (state.activeLobbyTab == lobbyTabsEnum.PACKAGEEXISTS && state.page != pages.SALE) {
          param3 = `חו''ל שלי`;
        }
        errorOnOTPStep1(state.otpPhoneForm.phone, param3);

        if (action.payload.subscriberNotExists) {
          state.otpData.otpPopupData = otpValidationPopupContent.isNotCellcomAccount;
        } else {
          state.otpData.otpPopupData = otpValidationPopupContent.otpGeneralError;
        }
        state.isShowPopup = true;
        state.popupReason = popupReasonEnum.OTP_RESULT;
        state.otpData.step1Error = true;
        return state;
      }
    },
    [verifyPhone.rejected]: (state, action) => {
      state.otpIsLoading = false;
      if (state.page == pages.SALE) {
        if (state.selectedAbroadPackage?.isFamilyBonus) state.otpDataChildren.saleOTPStep = saleOTPSteps.MOBILE_INPUT;
        else state.otpData.saleOTPStep = saleOTPSteps.MOBILE_INPUT;
      }
    },
    [validateOtpCode.fulfilled]: (state, action) => {
      state.otpIsLoading = false;
      if (!action.payload.error) {
        if (state.page == pages.SALE) {
        }

        if (!state.selectedAbroadPackage?.isFamilyBonus) {
          if (action.payload) {
            state.otpData.step2Validated = true;
            state.otpData.saleOTPStep = saleOTPSteps.STEP_2_VALIDATED;
          }
          return state;
        } else {
          if (action.payload) {
            state.otpDataChildren.step2Validated = true;
            state.otpDataChildren.saleOTPStep = saleOTPSteps.STEP_2_VALIDATED;
          }
          return state;
        }
      }
      if (action.payload.errorData.errorCode == '131') {
        if (state.selectedAbroadPackage?.isFamilyBonus) {
          state.otpDataChildren.wrongOtpMessage = 'מממ...זה לא הקוד ששלחנו. בואו ננסה שוב';
          state.otpDataChildren.showWrongOtpCodeMessage = true;
          if (state.page == pages.SALE) {
            state.otpDataChildren.saleOTPStep = saleOTPSteps.OTP;
          }
        } else {
          state.otpData.wrongOtpMessage = 'מממ...זה לא הקוד ששלחנו. בואו ננסה שוב';
          state.otpData.showWrongOtpCodeMessage = true;
          if (state.page == pages.SALE) {
            state.otpData.saleOTPStep = saleOTPSteps.OTP;
          }
        }
      } else if (action.payload.errorData.codeError == '1003') {
        if (state.selectedAbroadPackage?.isFamilyBonus) {
          state.otpDataChildren.wrongOtpMessage = 'קוד שקיבלתם כבר לא בתוקף. כדי לשמור על הפרטים שלכם, נתחיל את התהליך מחדש';
          state.otpDataChildren.showWrongOtpCodeMessage = true;
          if (state.page == pages.SALE) {
            state.otpDataChildren.saleOTPStep = saleOTPSteps.MOBILE_INPUT;
          } else {
            state.otpDataChildren = otpInitialState;
          }
        } else {
          state.otpData.wrongOtpMessage = 'קוד שקיבלתם כבר לא בתוקף. כדי לשמור על הפרטים שלכם, נתחיל את התהליך מחדש';
          state.otpData.showWrongOtpCodeMessage = true;
          if (state.page == pages.SALE) {
            state.otpData.saleOTPStep = saleOTPSteps.MOBILE_INPUT;
          } else {
            state.otpData = otpInitialState;
          }
        }
      } else if (action.payload.errorData.errorCode == '39') {
        state.otpData.otpSubscriberNotExist = true;
        state.otpData.otpPopupData = otpValidationPopupContent.isNotCellcomAccount;
        state.isShowPopup = true;
        state.popupReason = popupReasonEnum.OTP_RESULT;
      } else {
        if (state.selectedAbroadPackage?.isFamilyBonus) {
          state.otpDataChildren.wrongOtpMessage = 'שגיאה';
          state.otpDataChildren.showWrongOtpCodeMessage = true;
          if (state.page == pages.SALE) {
            state.otpDataChildren.saleOTPStep = saleOTPSteps.MOBILE_INPUT;
          } else {
            state.otpDataChildren = otpInitialState;
          }
        } else {
          state.otpData.wrongOtpMessage = 'שגיאה';
          state.otpData.showWrongOtpCodeMessage = true;
          if (state.page == pages.SALE) {
            state.otpData.saleOTPStep = saleOTPSteps.MOBILE_INPUT;
          } else {
            state.otpData = otpInitialState;
          }
        }
      }

      return state;
    },
    [validateOtpCode.rejected]: (state, action) => {
      state.otpIsLoading = false;
      if (state.page == pages.SALE) {
        state.otpData.saleOTPStep = saleOTPSteps.MOBILE_INPUT;
      }
    },
    [validateCustomerType.pending]: (state, action) => {
      state.validateCustomerTypeRequestCompleted = false;
      if (state.page == pages.SALE) {
        if (state.selectedAbroadPackage?.isFamilyBonus) state.otpDataChildren.saleOTPStep = saleOTPSteps.LOADER;
        else state.otpData.saleOTPStep = saleOTPSteps.LOADER;
      } else {
        state.generalLoader = true;
      }
      state.otpData.otpSubscriberNotExist = false;
    },
    [validateCustomerType.fulfilled]: (state, action) => {
      state.generalLoader = false;
      state.validateCustomerTypeRequestCompleted = true;
      if (!action.payload.error && action.payload.response.returnResponse) {
        state.otpData.validatedPhoneNumber = action.payload.validatedPhoneNumber;
        state.otpData.otpPhone = action.payload.validatedPhoneNumber;
        state.otpData.isOTPValidated = true;
        state.otpData.validatedCostumerData = action.payload.response;

        if (!action.payload.response.isSeparatedSale) {
          let validationObj = validateOtpDataWithCustomerRequest(action.payload.response, state, action.payload.cellularSubscribers || []);
          if (validationObj) {
            state.otpData.otpPopupData = validationObj;
            state.popupReason = popupReasonEnum.OTP_RESULT;

            state.isShowPopup = true;

            if (
              (state.page == pages.SALE && validationObj.id == 'isBusinessAccount') ||
              validationObj.id == 'isCellcomWorkerOtpSale' ||
              validationObj.id == 'isCellcomWorkerOtpLobby' ||
              validationObj.id == 'autoPackageExists' ||
              action.payload.isLoginAuth
            ) {
              state.otpData.saleOTPStep = saleOTPSteps.AFTER_INPUT;
            } else {
              state.otpData.saleOTPStep = saleOTPSteps.MOBILE_INPUT;
            }
          } else {
            state.otpData.saleOTPStep = saleOTPSteps.AFTER_INPUT;
          }

          if (
            !validationObj ||
            (validationObj && (validationObj.id == 'isCellcomWorkerOtpLobby' || validationObj.id == 'isCellcomWorkerOtpSale'))
          ) {
            otpValidatedEventGAReport({
              page: state.page,
              startedFromPackage: state.startedFromPackage,
            });

            if (action.payload.response.accountType != customerTypeEnum.UNKNOWN) {
              state.activeLobbyTab =
                action.payload.response.accountType == customerTypeEnum.PRIVATE ? lobbyTabsEnum.PRIVATE : lobbyTabsEnum.BUSINESSACCOUNT;
            }
          }
        } else {
          otpValidatedSeparatedSale();
          if (action.payload.response.noRoamSockExists) {
            state.otpData.otpPopupData = otpValidationPopupContent.abroadIsClosedForAccount;
            state.isShowPopup = true;
            state.popupReason = popupReasonEnum.OTP_RESULT;
            state.otpData.saleOTPStep = saleOTPSteps.MOBILE_INPUT;
          } else {
            if (action.payload.response.autoPackageExists || action.payload.response.rollingPackageExists) {
              if (action.payload.response.autoPackageExists) {
                state.otpData.otpPopupData = otpValidationPopupContent.separatedSaleAutoPackage;
              } else if (action.payload.response.rollingPackageExists) {
                state.otpData.otpPopupData = otpValidationPopupContent.separatedSaleRollingPackage;
              }
              state.isShowPopup = true;
              state.popupReason = popupReasonEnum.OTP_RESULT;
              state.otpData.saleOTPStep = saleOTPSteps.MOBILE_INPUT;
            } else {
              state.otpData.saleOTPStep = saleOTPSteps.AFTER_INPUT;
              if (
                !action.payload.response.shadowData.shadowClientValid ||
                (!action.payload.response.shadowData.effectiveSocExists && action.payload.response.shadowData.status.toUpperCase() == 'S')
              ) {
                state.shadowProcessStage = 'DETAILS_INSERT';
              } else {
                state.shadowProcessStage = 'ID_INSERT';
              }
            }
          }
        }
        if (!state.isJETAuthentication) {
          const storeData = {
            validatedPhone: action.payload.validatedPhoneNumber,
          };
          setItem('abroadOTP', storeData, true);
        }
        try {
          let subscriber,
            param4,
            param3 = '';
          const channel = state.activeLobbyTab && state.activeLobbyTab == 'businessAccount' ? 'WebsiteBusiness' : 'WebsitePrivate';
          const param1 = state.isJETAuthentication ? 'JET' : 'WEBSITE';

          if (state.selectedAbroadPackage?.isFamilyBonus) {
            subscriber = state.otpDataChildren.otpPhone || '';
            param3 = 'בני משפחות';
            param4 = 'מספר מנוי ראשי - ' + state.otpData.otpPhone;
          } else {
            subscriber = state.otpData.otpPhone || '';
            param3 = action.payload.response?.isSeparatedSale ? 'מכר בהפרדה' : '';
          }
          dwhValidateCustomer({channel, subscriber, param1, param4, param3});
        } catch {}

        return state;
      } else {
        state.otpData.otpPopupData = otpValidationPopupContent.otpGeneralError;
        state.isShowPopup = true;
        state.popupReason = popupReasonEnum.OTP_RESULT;
        state.otpData.otpPhone = '';

        if (state.page == pages.SALE) {
          if (action.payload.isLoginAuth) {
            state.otpData.saleOTPStep = saleOTPSteps.AFTER_INPUT;
          } else {
            state.otpData.saleOTPStep = saleOTPSteps.MOBILE_INPUT;
          }
        }
        if (action?.payload?.errorData?.response?.status != '403' || state.isJETAuthentication) {
          let subscriber,
            param4,
            param3 = '';
          const channel = state.activeLobbyTab && state.activeLobbyTab == 'businessAccount' ? 'WebsiteBusiness' : 'WebsitePrivate';
          const param1 = state.isJETAuthentication ? 'JET' : 'WEBSITE';

          if (state.selectedAbroadPackage?.isFamilyBonus) {
            param3 = 'בני משפחות';
            param4 = 'מספר מנוי ראשי - ' + state.otpData.otpPhone;
          }
          subscriber = action.payload.validatedPhoneNumber || '';

          dwhErrorValidateCustomer({
            channel,
            subscriber,
            param1,
            param4,
            param3,
          });
        }

        return state;
      }
    },
    [validateCustomerType.rejected]: (state, action) => {
      state.otpIsLoading = false;
      if (state.page == pages.SALE) {
        state.otpData.saleOTPStep = saleOTPSteps.MOBILE_INPUT;
      }
    },
    [abroadRetrieveCustomerDataFamily.pending]: (state, action) => {
      if (state.page == pages.SALE) {
        state.otpDataChildren.saleOTPStep = saleOTPSteps.LOADER;
      }
    },
    [abroadRetrieveCustomerDataFamily.rejected]: (state, action) => {
      if (state.page == pages.SALE) {
        state.otpDataChildren.saleOTPStep = saleOTPSteps.MOBILE_INPUT;
      }
    },

    [abroadRetrieveCustomerDataFamily.fulfilled]: (state, action) => {
      if (!action.payload?.error && action.payload?.response?.returnResponse) {
        if (action.payload?.response?.isDefaultSoc?.length > 0) {
          const defaultPackage = action.payload?.response?.isDefaultSoc.find((defPackage) => defPackage.alretPopUpToUser == true);

          if (defaultPackage) {
            state.otpDataChildren.otpPopupData = otpValidationPopupContent.defaultPackageExists;
            state.isShowPopup = true;
            state.popupReason = popupReasonEnum.OTP_RESULT;
            state.otpDataChildren.defaultSOC = defaultPackage;
            state.otpDataChildren.saleOTPStep = saleOTPSteps.AFTER_INPUT;
            state.saleActiveStep = saleActiveStep.TICKET;
            return state;
          }
        } else if (action.payload?.response?.subsriberSurfIsBlocked) {
          state.isShowPopup = true;
          state.popupReason = popupReasonEnum.DATA_USAGE_IS_BLOCKED;
          state.otpDataChildren.saleOTPStep = saleOTPSteps.AFTER_INPUT;
          state.saleActiveStep = saleActiveStep.TICKET;
          return state;
        }

        state.otpDataChildren.readyToPurchase = true;
        return state;
      } else {
        state.otpDataChildren.otpPopupData = otpValidationPopupContent.otpGeneralError;
        state.isShowPopup = true;
        state.popupReason = popupReasonEnum.OTP_RESULT;
        state.saleActiveStep = saleActiveStep.TICKET;
        return state;
      }
    },
    [validateCustomerFamilyType.rejected]: (state, action) => {
      state.otpIsLoading = false;
      if (state.page == pages.SALE) {
        state.otpDataChildren.saleOTPStep = saleOTPSteps.MOBILE_INPUT;
      }
    },
    [validateCustomerFamilyType.pending]: (state, action) => {
      if (state.page == pages.SALE) {
        state.otpDataChildren.saleOTPStep = saleOTPSteps.LOADER;
      } else {
        state.otpIsLoading = true;
      }
    },
    [validateCustomerFamilyType.fulfilled]: (state, action) => {
      state.otpIsLoading = false;
      state.otpCodeForm.verifyCode = '';
      if (!action.payload.error && action.payload.response.returnResponse) {
        let validationObj = validateOtpDataFamilyWithChildrenRequest(action.payload.response);

        state.otpDataChildren.isOTPValidated = true;
        state.otpDataChildren.validatedCostumerData = action.payload.response;

        if (action.payload.response.accountType != customerTypeEnum.UNKNOWN) {
          state.activeLobbyTab =
            action.payload.response.accountType == customerTypeEnum.PRIVATE ? lobbyTabsEnum.PRIVATE : lobbyTabsEnum.BUSINESSACCOUNT;
        }

        if (validationObj) {
          state.otpDataChildren.otpPopupData = validationObj;
          state.isShowPopup = true;
          state.popupReason = popupReasonEnum.OTP_RESULT;

          if (
            (state.page == pages.SALE && validationObj.id == 'isBusinessAccount') ||
            validationObj.id == 'isCellcomWorkerOtpSale' ||
            validationObj.id == 'isCellcomWorkerOtpSaleFamily' ||
            validationObj.id == 'isCellcomWorkerOtpLobby'
            // || action.payload.isLoginAuth
          ) {
            state.otpDataChildren.saleOTPStep = saleOTPSteps.AFTER_INPUT;
          } else {
            state.otpDataChildren.saleOTPStep = saleOTPSteps.MOBILE_INPUT;
          }
        } else {
          state.otpDataChildren.saleOTPStep = saleOTPSteps.AFTER_INPUT;
          if (action.payload.response.capSoc && state.selectedAbroadPackage.type != PackageType.Data) {
            state.isShowPopup = true;
            state.popupReason = popupReasonEnum.CAP_SOC;
            state.saleActiveStep = saleActiveStep.TICKET;
            return state;
          }
        }

        return state;
      } else {
        state.otpDataChildren.otpPopupData = otpValidationPopupContent.otpGeneralError;
        state.isShowPopup = true;
        state.popupReason = popupReasonEnum.OTP_RESULT;
        if (action.payload.isLoginAuth) {
          state.otpDataChildren.saleOTPStep = saleOTPSteps.AFTER_INPUT;
        } else {
          state.otpDataChildren.saleOTPStep = saleOTPSteps.MOBILE_INPUT;
        }

        return state;
      }
    },
    [validateCustomerTypeBusinessIndividual.pending]: (state, action) => {
      state.generalLoader = true;
      state.businessIndividualData.closedForData = false;
      state.businessIndividualData.autoPackageExist = false;
      if (!action.meta.arg.startDate && !action.meta.arg.endDate && !action.meta.arg.socCode) {
        state.businessIndividualData.selectedAccountNumber = '';
        state.businessIndividualData.isSelectedAccountBelongsToSelectedHetPay = true;
        state.businessIndividualData.subStatusIsA = true;
        state.businessIndividualData.dummySubIndIsNull = true;
      }
    },
    [validateCustomerTypeBusinessIndividual.fulfilled]: (state, action) => {
      if (!action.payload.error) {
        if (!action.payload.response.isBelongsToOrgId) {
          state.businessIndividualData.isSelectedAccountBelongsToSelectedHetPay = false;
          state.generalLoader = false;
          let msg = `מנוי זה לא שייך לארגון`;
          dwhSelectAccountBusinessIndividualReport(action.payload.account, msg);
          return state;
        } else if (!action.payload.response.subStatusIsA) {
          state.businessIndividualData.subStatusIsA = false;
          state.generalLoader = false;
          let msg = `מנוי מושהה, לא ניתן להמשיך`;
          dwhSelectAccountBusinessIndividualReport(action.payload.account, msg);
          return state;
        } else if (!action.payload.response.dummySubIndIsNull) {
          state.businessIndividualData.dummySubIndIsNull = false;
          state.generalLoader = false;
          let msg = `המספר שהוזן הינו משני, לא ניתן להמשיך`;
          dwhSelectAccountBusinessIndividualReport(action.payload.account, msg);
          return state;
        }

        state.businessIndividualData.allowedToAbroadLobby = true;
        state.businessIndividualData.selectedAccountNumber = action.payload.account;
        state.businessIndividualData.isSelectingAccount = false;
        state.businessIndividualData.viewWithoutPurchaseStatus = false;
        state.businessIndividualData.fullFinancingOrSecurityLevelRed = action.payload.response?.fullFinancingOrSecurityLevelRed;
        state.businessIndividualData.isFullFinancing = action.payload.response?.isFullFinancing;
        state.businessIndividualData.isSplitAccount = action.payload.response?.isSplit;
        let ans = validateSelectedAccountBusinessIndividual(action.payload.response, action.payload.fullValidation);
        if (!ans) {
          state.generalLoader = false;
          if (action.payload.fullValidation) {
            if (action.payload.response.subsriberSurfIsBlocked) {
              state.popupReason = popupReasonEnum.DATA_USAGE_IS_BLOCKED;
              state.isShowPopup = true;
              dwhDataUsageBlockedPopupBusinessIndividual();
            } else {
              state.businessIndividualData.readyForPurchase = true;
            }
          } else {
            dwhSelectAccountBusinessIndividualReport(action.payload.account, null);
          }
          return state;
        } else {
          if (action.payload.fullValidation) {
            state.businessIndividualData.closedForData = action.payload.response.subsriberSurfIsBlocked;
            if (action.payload.response.subsriberSurfIsBlocked) {
              dwhDataUsageBlockedPopupBusinessIndividual(); //dwh
            }
            if (otpValidationPopupContent.abroadIsClosedForAccountBusinessIndividual) {
              dwhRoamPopupBusinessIndividual(); //dwh
            }
          } else {
            let msg;
            switch (ans) {
              case otpValidationPopupContent.autoPackageExistsBusinessIndividual:
                msg = 'AUTO Package';
                break;
              case otpValidationPopupContent.customerGoldClass:
                msg = 'מנוי זהב';
                break;
              case otpValidationPopupContent.pricePlanVoiceExists:
                msg = 'מסגרת התוכנית תמחור';
                break;
              default:
                break;
            }
            dwhSelectAccountBusinessIndividualReport(action.payload.account, msg);
          }

          if (ans == otpValidationPopupContent.autoPackageExistsBusinessIndividual) {
            dwhAutoPackagePopupBusinessIndividual();
            state.businessIndividualData.autoPackageExist = true;
          }

          state.businessIndividualData.popupData = ans;
          state.isShowPopup = true;
          state.popupReason = popupReasonEnum.OTP_RESULT;
          state.generalLoader = false;
        }

        return state;
      }
      dwhSelectAccountBusinessIndividualReport(action.payload.account, 'General Error');
      state.businessIndividualData.popupData = otpValidationPopupContent.otpGeneralError;
      state.isShowPopup = true;
      state.popupReason = popupReasonEnum.OTP_RESULT;
      state.generalLoader = false;
      return state;
    },

    [checkFamilyBundleSubscribersBlockage.pending]: (state, action) => {
      const {packageType, phones} = action.meta.arg || {};
      const isDataPackage = packageType && String(packageType).toUpperCase().includes('DATA');
      if (isDataPackage && phones?.length > 0) {
        state.saleActiveStep = saleActiveStep.LOADER;
      }
    },
    [checkFamilyBundleSubscribersBlockage.fulfilled]: (state, action) => {
      if (action.payload?.hasBlocked) {
        state.saleActiveStep = saleActiveStep.TICKET;
      }
    },
    [checkFamilyBundleSubscribersBlockage.rejected]: (state) => {
      state.saleActiveStep = saleActiveStep.TICKET;
      state.otpData.otpPopupData = otpValidationPopupContent.otpGeneralError;
      state.isShowPopup = true;
      state.popupReason = popupReasonEnum.OTP_RESULT;
    },
    [abroadRetrieveCustomerData.pending]: (state, action) => {
      state.saleActiveStep = saleActiveStep.LOADER;
    },
    [abroadRetrieveCustomerData.fulfilled]: (state, action) => {
      applyAbroadRetrieveResultToState(state, action.payload?.result, {
        validatedPhone: action.payload?.validatedPhone,
        keepLoaderStep: false,
      });
    },
    [getCustomerCellularList.pending]: (state, action) => {
      state.relatedPhoneNumbersRequestCompleted = false;
      return state;
    },
    [getCustomerCellularList.fulfilled]: (state, action) => {
      state.relatedPhoneNumbersRequestCompleted = true;
      state.otpData.saleOTPStep = saleOTPSteps.AFTER_INPUT;
      if (!action.payload.error) {
        if (action.payload.data?.length > 0) {
          state.relatedPhoneNumbers = action.payload.data;
        } else {
          state.otpData.otpPopupData = otpValidationPopupContent.subStatusIsA;
          state.isShowPopup = true;
          state.popupReason = popupReasonEnum.OTP_RESULT;
        }

        return state;
      }
      return state;
    },

    [fetchPackageClient.pending]: (state, action) => {
      state.statusRequest = 'pending';
      state.searchIsLoading = true;

      return state;
    },
    [fetchPackageClient.fulfilled]: (state, action) => {
      const message = 'Searched for package in lobby';
      const param2 = state.selectedAbroadPackage?.socCode;
      const {channel, subscriber, param1, param3, param4, param5, param6, param7} = getDwhParams(state);

      dwhPackageSearchActivation({channel, subscriber, message, param1, param2, param3, param4, param5, param6, param7});

      state.searchIsLoading = false;
      state.executePackagesSearch = false;
      if (!action.payload.error) {
        state.statusRequest = 'completed';
        let fetchedPackages = action.payload.response;
        if (action.payload.response.businessIndividual) {
          fetchedPackages.matchExact = lodash.filter(fetchedPackages.matchExact, function (p) {
            return p.isBankOrByUse == 'Bank';
          });
        }

        state.abroadPackagesList = fetchedPackages;
        return state;
      } else {
        state.statusRequest = 'rejected';
      }
    },
    [fetchPackageClient.rejected]: (state, action) => {
      state.statusRequest = 'rejected';
      state.searchIsLoading = false;
      return state;
    },

    [fetchPackageBusinessIndividualClient.pending]: (state, action) => {
      state.statusRequest = 'pending';
      state.generalLoader = true;
      return state;
    },
    [fetchPackageBusinessIndividualClient.fulfilled]: (state, action) => {
      state.generalLoader = false;
      if (!action.payload.error) {
        state.statusRequest = 'completed';
        if (action.payload.response?.matchExact.length == 0 && action.payload.response?.validyButNotExact?.length == 0) {
          gaPackagesEmptyResult(true);
        }
        state.abroadPackagesList = action.payload.response;

        return state;
      } else {
        state.statusRequest = 'rejected';
        state.abroadPackagesList = null;
        state.isShowPopup = true;
        state.popupReason = popupReasonEnum.ERROR_MESSAGE;
        state.businessIndividualData.popupData = otpValidationPopupContent.errorOnFetchPackagesBusinessIndividual;
      }
    },
    [fetchPackageBusinessIndividualClient.rejected]: (state, action) => {
      state.statusRequest = 'rejected';
      state.searchIsLoading = false;
      state.abroadPackagesList = null;
      state.isShowPopup = true;
      state.popupReason = popupReasonEnum.ERROR_MESSAGE;
      state.businessIndividualData.popupData = otpValidationPopupContent.errorOnFetchPackagesBusinessIndividual;
      return state;
    },
    [fetchPackagePopular.pending]: (state, action) => {
      state.statusRequest = 'pending';
      state.popularIsLoading = true;

      return state;
    },
    [fetchPackagePopular.fulfilled]: (state, action) => {
      state.popularIsLoading = false;
      if (!action.payload.error) {
        state.statusRequest = 'completed';
        state.abroadPackagesPopular = action.payload.response;
      } else {
        state.statusRequest = 'rejected';
      }
      return state;
    },
    [fetchPackagePopular.rejected]: (state, action) => {
      state.statusRequest = 'rejected';
      state.popularIsLoading = false;
      return state;
    },
    [fetchPackagePopularMarket.pending]: (state, action) => {
      state.statusRequest = 'pending';
      state.popularIsLoading = true;

      return state;
    },
    [fetchPackagePopularMarket.fulfilled]: (state, action) => {
      state.popularIsLoading = false;

      if (!action.payload.error) {
        state.statusRequest = 'completed';
        // Combine current response with previous response
        state.abroadPackagesPopularMarket = {
          ...state.abroadPackagesPopularMarket,
          [action.payload.id]: action.payload.response,
        };
      } else {
        state.statusRequest = 'rejected';
      }
      return state;
    },

    [fetchPackagePopularMarket.rejected]: (state, action) => {
      state.statusRequest = 'rejected';
      state.popularIsLoading = false;
      return state;
    },
    [fetchPackageBySocCode.pending]: (state, action) => {
      state.statusRequest = 'pending';
      state.termsIsLoading = true;

      return state;
    },
    [fetchPackageBySocCode.fulfilled]: (state, action) => {
      state.termsIsLoading = false;
      if (!action.payload.error) {
        state.statusRequest = 'completed';
        state.selectedAbroadPackage = action.payload.response;
        state.selectedAbroadPackageFolderType = ''; //to do get block ID from URL(not implemented yet)
        state.startedFromPackage = true;
        state.selectedOnSalePageFlag = true;
      } else {
        state.statusRequest = 'rejected';
      }
      return state;
    },
    [getAbroadFamilyPackageInfo.pending]: (state, action) => {
      state.generalLoader = true;
      return state;
    },
    [getAbroadFamilyPackageInfo.fulfilled]: (state, action) => {
      state.generalLoader = false;
      if (!action.payload.error) {
        state.selectedAbroadPackage.familyPackageInfo = action.payload;
      }
      return state;
    },
    [fetchPackageBySocCode.rejected]: (state, action) => {
      state.statusRequest = 'rejected';
      state.termsIsLoading = false;
      return state;
    },
    [fetchPackage.pending]: (state, action) => {
      state.statusRequest = 'pending';
      state.searchIsLoading = true;

      return state;
    },
    [fetchPackage.fulfilled]: (state, action) => {
      state.searchIsLoading = false;
      if (!action.payload.error) {
        state.statusRequest = 'completed';
        state.selectedAbroadPackage = action.payload.response;
        state.selectedAbroadPackageFolderType = ''; //to do get block ID from URL(not implemented yet)
        state.startedFromPackage = true;
        state.selectedOnSalePageFlag = true;
      } else {
        state.statusRequest = 'rejected';
      }
      return state;
    },
    [fetchPackage.rejected]: (state, action) => {
      state.statusRequest = 'rejected';
      state.searchIsLoading = false;
      return state;
    },
    [abroadRemoveAndAddSoc.pending]: (state, action) => {
      state.saleActiveStep = saleActiveStep.LOADER;
    },
    [abroadRemoveAndAddSoc.fulfilled]: (state, action) => {
      state.otpData.readyToPurchase = false;
      if (!action.payload.error) {
        if (action.payload.Body.isSuccess) {
          // Keep purchasedFamilyBundleData only for the purchase flow, not for member-edit updates from existing packages.
          if (
            !action.payload.isFamilyBundleEdit &&
            (state.familyBundleData.flightManager || state.familyBundleData.selectedMembers.length > 0)
          ) {
            state.purchasedFamilyBundleData = {
              flightManager: state.familyBundleData.flightManager,
              selectedMembers: [...state.familyBundleData.selectedMembers],
            };
          } else if (action.payload.isFamilyBundleEdit) {
            state.purchasedFamilyBundleData = null;
          }
          state.selectedAbroadPackage = {
            ...state.selectedAbroadPackage,
            addons: action.payload.Body.addonsUnderPackage,
            showCallFilterMsg: action.payload.Body.callFilterMessage,
          };
          // FBM01 can arrive with isSuccess:true (partial success — some members failed)
          if (action.payload.Body.codeError === 'FBM01') {
            const failedMembers = action.payload.Body.FailedMembers || action.payload.Body.failedMembers || [];
            state.familyBundleData.failedMembers = failedMembers;
            state.familyBundleData.errorType = 'members';
          }
          state.saleActiveStep = saleActiveStep.COMPLETED_SUCCESSFUL;
        } else {
          // if familybundle - capture additional data the backend returns (failed members / flight manager)
          if (state.selectedAbroadPackage?.isFamilyBundle) {
            const failedMembers = action.payload.Body.FailedMembers || action.payload.Body.failedMembers || [];
            const flightManager = action.payload.Body.FlightManager || action.payload.Body.flightManager || null;

            // error code is FM1? (flight manager problem)
            if (action.payload.Body.codeError == 'FM1') {
              if (flightManager) {
                state.familyBundleData.flightManager = flightManager;
              }
              state.familyBundleData.errorType = 'flightManager';
              state.saleActiveStep = saleActiveStep.TICKET;
              state.popupReason = popupReasonEnum.FAMILY_BUNDLE_FLIGHT_MANAGER_ERROR;
              state.isShowPopup = true;
            } else if (action.payload.Body.codeError == 'FBCO1') {
              // Save failed members and open the family-bundle cellular-off popup
              state.familyBundleData.failedMembers = failedMembers;
              state.familyBundleData.errorType = 'cellularOff';
              state.saleActiveStep = saleActiveStep.TICKET;
              state.popupReason = popupReasonEnum.FAMILY_BUNDLE_CELLULAR_DATA_OFF;
              state.isShowPopup = true;
            } else if (action.payload.Body.codeError == 'FBM01') {
              state.familyBundleData.failedMembers = failedMembers;
              state.familyBundleData.errorType = 'members';
              state.saleActiveStep = saleActiveStep.COMPLETED_SUCCESSFUL;
            }
            // Clear operational data after any error (errorType/failedMembers kept for popup display)
            state.familyBundleData.selectedMembers = [];
            state.familyBundleData.removedMembers = [];
          } else {
            state.saleActiveStep = saleActiveStep.COMPLETED_WITH_ERROR;
          }
          state.completedWithCode = action.payload.Body.codeError;
          state.isOverlappingPackage = action.payload.Body.isOverlappingPackage;
        }
      } else {
        state.saleActiveStep = saleActiveStep.COMPLETED_WITH_ERROR;
        state.completedWithCode = action.payload.errorCode;
      }
      return state;
    },
    [abroadRemoveAndAddSoc.rejected]: (state, action) => {
      state.otpData.readyToPurchase = false;
      state.saleActiveStep = saleActiveStep.COMPLETED_WITH_ERROR;
      state.completedWithCode = '99';
      return state;
    },
    [addAddonToPackage.pending]: (state, action) => {
      state.isLoading = true;
      return state;
    },
    [addAddonToPackage.fulfilled]: (state, action) => {
      if (action?.payload?.Body?.isSuccess) {
        state.businessIndividualData.popupData = otpValidationPopupContent.addonPurchaseSucceeded;

        var addons = state.selectedAbroadPackage.addons.map((addon) => {
          if (addon.socCode === action?.payload?.soc) {
            return {...addon, isPurchased: true};
          }
          return addon;
        });
        state.selectedAbroadPackage = {...state.selectedAbroadPackage, addons};
        gaSuccessOrderAddon();
      } else {
        state.businessIndividualData.popupData = otpValidationPopupContent.addonPurchaseFault;
        gaFailedOrderAddon(action?.payload?.Body?.codeError);
      }

      state.popupReason = popupReasonEnum.ADDON_PURCHASE_RESULT;
      state.isShowPopup = true;
      state.isLoading = false;
      return state;
    },
    [addAddonToPackage.rejected]: (state, action) => {
      state.businessIndividualData.popupData = otpValidationPopupContent.addonPurchaseFault;
      state.popupReason = popupReasonEnum.ADDON_PURCHASE_RESULT;
      state.isShowPopup = true;
      state.isLoading = false;
      state.completedWithCode = '99';
      return state;
    },
    [abroadRemoveAndAddSocBusinessIndividual.pending]: (state, action) => {
      state.saleActiveStep = saleActiveStep.LOADER;
    },
    [abroadRemoveAndAddSocBusinessIndividual.fulfilled]: (state, action) => {
      state.businessIndividualData.readyForPurchase = false;
      state.businessIndividualData.buyPackageInSplit = null;
      if (!action.payload.error) {
        if (action.payload.Body.isSuccess) {
          state.saleActiveStep = saleActiveStep.COMPLETED_SUCCESSFUL;
          var currentData = {
            ...state,
            _subscriber: action.meta.arg?.subscriberNumber,
          };
          selfServiceDwh.AbroadPackage.Purchase(currentData);

          if (action.payload.Body.returnCodeMessage === 'FailedAtRemovingSurfBlock' && action.payload.Body.isSuccess) {
            state.failedAtRemovingSurfBlock = true;
            state.isShowPopup = true;
            state.popupReason = popupReasonEnum.FAILED_SURF_BLOCK_REMOVE;
          }
          state.selectedAbroadPackage.showCallFilterMsg = action.payload.Body.callFilterMessage || false;
        } else {
          state.saleActiveStep = saleActiveStep.COMPLETED_WITH_ERROR;
          state.completedWithCode = action.payload.Body.codeError;
          state.isOverlappingPackage = action.payload.Body.isOverlappingPackage;
        }
      } else {
        state.saleActiveStep = saleActiveStep.COMPLETED_WITH_ERROR;
        state.completedWithCode = action.payload.errorCode;
      }

      return state;
    },
    [abroadRemoveAndAddSocBusinessIndividual.rejected]: (state, action) => {
      state.otpData.readyToPurchase = false;
      state.saleActiveStep = saleActiveStep.COMPLETED_WITH_ERROR;
      state.completedWithCode = '99';
      return state;
    },
    [GetShadowSubscriberData.fulfilled]: (state, action) => {
      if (!action.payload.error) state.otpData.validatedCostumerData.shadowData = action.payload.Body;
      return state;
    },
    [RemoveAndAddShadowSoc.pending]: (state, action) => {
      state.saleActiveStep = saleActiveStep.LOADER;
    },
    [RemoveAndAddShadowSoc.fulfilled]: (state, action) => {
      state.otpData.readyToPurchase = false;

      if (!action.payload.error) {
        if (action.payload.Body.isSuccess) {
          state.shadowForm = {
            customerId: '',
            customerFirstName: '',
            customerLastName: '',
            customerEmail: '',
          };
          state.shadowNewFromExisting = false;
          state.selectedAbroadPackage = {...state.selectedAbroadPackage, addons: action.payload.Body.addonsUnderPackage};
          state.saleActiveStep = saleActiveStep.COMPLETED_SUCCESSFUL;
        } else {
          state.saleActiveStep = saleActiveStep.COMPLETED_WITH_ERROR;
          state.completedWithCode = action.payload.Body.codeError;
          state.isOverlappingPackage = action.payload.Body.isOverlappingPackage;
        }
      } else {
        state.saleActiveStep = saleActiveStep.COMPLETED_WITH_ERROR;
        state.completedWithCode = action.payload.errorCode;
      }

      return state;
    },
    [RemoveAndAddShadowSoc.rejected]: (state, action) => {
      state.otpData.readyToPurchase = false;
      state.saleActiveStep = saleActiveStep.COMPLETED_WITH_ERROR;
      state.completedWithCode = '99';
      return state;
    },
    [abroadRemoveAndAddSocFamily.pending]: (state, action) => {
      state.saleActiveStep = saleActiveStep.LOADER;
    },
    [abroadRemoveAndAddSocFamily.fulfilled]: (state, action) => {
      state.otpDataChildren.readyToPurchase = false;
      if (!action.payload.error) {
        if (action.payload.Body.isSuccess) {
          // Save family bundle data before it gets cleared
          if (state.familyBundleData.flightManager || state.familyBundleData.selectedMembers.length > 0) {
            state.purchasedFamilyBundleData = {
              flightManager: state.familyBundleData.flightManager,
              selectedMembers: [...state.familyBundleData.selectedMembers],
            };
          }
          state.selectedAbroadPackage = {...state.selectedAbroadPackage, addons: action.payload.Body.addonsUnderPackage};
          state.otpData.isFamilyProcess = false;
          state.saleActiveStep = saleActiveStep.COMPLETED_SUCCESSFUL;
        } else {
          state.saleActiveStep = saleActiveStep.COMPLETED_WITH_ERROR;
          state.completedWithCode = action.payload.Body.codeError;
        }
      } else {
        state.saleActiveStep = saleActiveStep.COMPLETED_WITH_ERROR;
        state.completedWithCode = action.payload.errorCode;
      }

      return state;
    },
    [abroadRemoveAndAddSocFamily.rejected]: (state, action) => {
      state.otpDataChildren.readyToPurchase = false;
      state.saleActiveStep = saleActiveStep.COMPLETED_WITH_ERROR;
      state.completedWithCode = '99';
      return state;
    },
    [validateAbroadCoupon.pending]: (state, action) => {
      state.coupon = {
        ...state.coupon,
        isLoading: true,
      };
      return state;
    },
    [validateAbroadCoupon.fulfilled]: (state, action) => {
      var body = action.payload.Body;
      var isSuccess = body.isSuccess;
      var messageDescription = !isSuccess ? 'קוד קופון לא קיים' : '';

      state.coupon = {
        ...state.coupon,
        isValid: body.isSuccess,
        voucherAmount: body.priceAfterVoucher,
        error: messageDescription,
        voucherCategory: body.voucherCategory,
        isLoading: false,
      };

      return state;
    },
    [validateAbroadCoupon.rejected]: (state, action) => {
      state.coupon = {
        isLoading: false,
      };
      return state;
    },
  },
});

export const {
  setNeedOtpInsurance,
  setFamilyBundleErrorType,
  setFamilyBundleFailedMembers,
  setSurfBlockedSubscriberPhones,
  setCurrentSubscriber,
  setBackupCG,
  setFromSuccess,
  setDataUsageKey,
  resetState,
  resetCoupon,
  setLoading,
  returnToLobby,
  epiStyleInitialization,
  setActiveLobbyTab,
  goToPage,
  setSaleActiveStep,
  setSearchingMode,
  saveSelectedCountry,
  saveSelectedCountries,
  saveSelectedCountriesUsedInSearch,
  setConnectedToSelectedCountry,
  saveNotSupportedCountries,
  setSearchCountryResults,
  removeFromSelectedCountries,
  changePhoneInputHandler,
  changePhoneInputHandlerWithExtendedPhone,
  onBlurHandler,
  validatePhoneHandler,
  saveSelectedStartDate,
  saveSelectedEndDate,
  setSelectedAbroadPackage,
  setSelectedFromSalePageFlag,
  setSearchedPackages,
  setOtpVerifyCode,
  clearOtpCode,
  clearOtpFormPhone,
  setOtpPhone,
  setChildrenOtpPhone,
  setOtpPopupData,
  removeOtpData,
  setJETAuthentication,
  setSaleOtpStep,
  setSaleOtpChildrenStep,
  setSwitchingAccount,
  setBuyPackageInSplit,
  validateOtpCodeHandler,
  hideOtpErrorMessage,
  hideOtpChildrenErrorMessage,
  setRemoveToCustomerSurfingBlockage,
  setReadyToPurchase,
  setReadyToPurchaseFamily,
  finalizeFamilyBundleInstallValidation,
  openModal,
  closeModal,
  setCurrentCountryDataToShow,
  setContext,
  saveToHistory,
  clearHistory,
  setUpdatedSocResultStatus,
  setSmallResolution,
  setIsPortrait,
  removeStateFromHistoryAction,
  setShadowFormData,
  setShadowCCUpdateMode,
  setLobbyTabsButtons,
  readyToPurchasePackageFamily,
  goToFamily,
  removeOtpDataChildren,
  updateTicketFromPackageManager,
  resetSocPackageRemoveStatus,
  setRemovedSurfSocResult,
  resetAddedExtendedPackageResult,
  setShadowProcessStage,
  setChosenSocForAction,
  setUpdatedCC,
  setNewPaymentShadow,
  eCommerceReportBuyFamilyPackage,
  eCommerceReportBuyRegularPackage,
  saveSelfCareBusinessIndividualBlockUrl,
  setIsSelectingAccountBusinessIndividual,
  setBusinessIndividualActiveStep,
  setViewWithoutPurchaseStatus,
  setShadowFromExisting,
  setAllowedToAbroadLobby,
  clearSearchParameters,
  clearBusinessIndividualDataOnSelecthetPay,
  clearBusinessIndividualSelectedAccountError,
  setStartedFromTracker,
  clearSelectedAbroadPackage,
  setPurchasedAddonsList,
  clearScreenILAddon,
  setShowAddonPopup,
  setReadyToPurchaseForBusinessIndividualAndSetAllowIndependentFuturePurchases,
  setRestrictedCode,
  displayRestrictedCodePopup,
  setOtpIsLoading,
  setIsOtpStep2Validated,
  removeFromBoughtPackages,
  filterCustomerFromBoughtPackages,
  setIsRegularAbroadCustomer,
  clearOtpForm,
  setFlightManager,
  setSelectedMembers,
  setRemovedMembers,
  toggleMemberSelection,
  setAvailableMembers,
  setMultipleBans,
  setSelectedBan,
  openMemberSelectionPopup,
  closeMemberSelectionPopup,
  toggleFlightManagerTooltip,
  savePurchasedFamilyBundleData,
  resetFamilyBundleData,
  resetFamilyPackageUsageDetails,
  clearPurchasedFamilyBundleData,
  setAbroadCoupon,
} = cellcomAbroadBlockSlice.actions;

export default cellcomAbroadBlockSlice.reducer;
